/* eslint-disable */
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { memo, useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { CheckSquareOutlined, InboxOutlined } from '@ant-design/icons';
import excel from 'assets/images/icons/excel.svg';
import ErrorModal from 'pages/comptroller/ErrorModal';

import { Button, Col, Flex, Form, Popover, Row, Upload } from 'antd';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useGetAllIdentityCaseMutation } from 'store/features/process/processApi';
import { handleFileUpload } from 'pages/globals/FileUploadExcel';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import dayjs from 'dayjs';
import { formatNumber, utcConverter } from './LeaseUtils/helper';
import _ from 'lodash';
import * as XLSX from 'xlsx';

const { Dragger } = Upload;
// export const parseAndFormatExcelDate = (excelDate) => {
// 	// Handle numeric Excel date format
// 	if (typeof excelDate === 'number') {
// 		const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
// 		const EXCEL_START_DATE = new Date(1900, 0, 1);
//
// 		// Adjust for Excel's leap year bug
// 		const daysToAdd = excelDate > 59 ? excelDate - 1 : excelDate;
//
// 		// Convert to JavaScript Date
// 		const date = new Date(EXCEL_START_DATE.getTime() + daysToAdd * MILLISECONDS_PER_DAY);
//
// 		// Format the date
// 		const year = date.getFullYear();
// 		const month = String(date.getMonth() + 1).padStart(2, '0');
// 		let day = String(date.getDate()).padStart(2, '0');
// 		day = String(+day || 1).padStart(2, '0'); // Ensure day is at least 1
//
// 		return `${year}-${month}-${day}`;
// 	}
//
// 	// Handle string date format (YYYY-MM-DD)
// 	if (typeof excelDate === 'string' && excelDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
// 		return excelDate;
// 	}
//
// 	// Try to parse as date string
// 	try {
// 		const date = new Date(excelDate);
// 		if (!isNaN(date.getTime())) {
// 			const year = date.getFullYear();
// 			const month = String(date.getMonth() + 1).padStart(2, '0');
// 			const day = String(date.getDate()).padStart(2, '0');
// 			return `${year}-${month}-${day}`;
// 		}
// 	} catch (e) {
// 		console.error("Couldn't parse date:", excelDate);
// 	}
//
// 	return ''; // Return empty string for invalid dates
// };
export const parseAndFormatExcelDate = (excelDate) => {
	// console.log('Input excelDate:', excelDate, 'Type:', typeof excelDate);

	// Handle Date objects (Excel might pass actual Date objects)
	if (excelDate instanceof Date) {
		if (!isNaN(excelDate.getTime())) {
			// Use UTC methods to avoid timezone shifts
			const year = excelDate.getUTCFullYear();
			const month = String(excelDate.getUTCMonth() + 1).padStart(2, '0');
			const day = String(excelDate.getUTCDate()).padStart(2, '0');
			const result = `${year}-${month}-${day}`;
			// console.log('Date object result:', result);
			return result;
		}
		return '';
	}

	// Handle numeric Excel date format
	if (typeof excelDate === 'number') {
		const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
		const EXCEL_START_DATE = new Date(1900, 0, 1);

		// Adjust for Excel's leap year bug
		const daysToAdd = excelDate > 59 ? excelDate - 1 : excelDate;

		// Convert to JavaScript Date
		const date = new Date(EXCEL_START_DATE.getTime() + daysToAdd * MILLISECONDS_PER_DAY);

		// Format the date using UTC to avoid timezone issues
		const year = date.getUTCFullYear();
		const month = String(date.getUTCMonth() + 1).padStart(2, '0');
		const day = String(date.getUTCDate()).padStart(2, '0');
		const result = `${year}-${month}-${day}`;
		// console.log('Numeric date result:', result);
		return result;
	}

	// Handle string formats
	if (typeof excelDate === 'string') {
		// Trim whitespace
		const trimmed = excelDate.trim();

		// Handle string date format (YYYY-MM-DD) - return as-is if valid
		if (trimmed.match(/^\d{4}-\d{2}-\d{2}$/)) {
			// console.log('YYYY-MM-DD format, returning as-is:', trimmed);
			return trimmed;
		}

		// Pattern: DD/MM/YYYY
		const ddmmyyyySlash = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
		const ddmmyyyyMatch = trimmed.match(ddmmyyyySlash);
		if (ddmmyyyyMatch) {
			const day = ddmmyyyyMatch[1].padStart(2, '0');
			const month = ddmmyyyyMatch[2].padStart(2, '0');
			const year = ddmmyyyyMatch[3];
			const result = `${year}-${month}-${day}`;
			// console.log('DD/MM/YYYY format result:', result);
			return result;
		}

		// Pattern: MM/DD/YYYY (if you need this format)
		const mmddyyyySlash = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
		const mmddyyyyMatch = trimmed.match(mmddyyyySlash);
		if (mmddyyyyMatch && parseInt(mmddyyyyMatch[1]) <= 12) {
			const month = mmddyyyyMatch[1].padStart(2, '0');
			const day = mmddyyyyMatch[2].padStart(2, '0');
			const year = mmddyyyyMatch[3];
			const result = `${year}-${month}-${day}`;
			// console.log('MM/DD/YYYY format result:', result);
			return result;
		}

		// Pattern: DD-MM-YYYY
		const ddmmyyyyDash = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
		const ddmmyyyyDashMatch = trimmed.match(ddmmyyyyDash);
		if (ddmmyyyyDashMatch) {
			const day = ddmmyyyyDashMatch[1].padStart(2, '0');
			const month = ddmmyyyyDashMatch[2].padStart(2, '0');
			const year = ddmmyyyyDashMatch[3];
			const result = `${year}-${month}-${day}`;
			// console.log('DD-MM-YYYY format result:', result);
			return result;
		}

		// Pattern: YYYY/MM/DD
		const yyyymmddSlash = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/;
		const yyyymmddMatch = trimmed.match(yyyymmddSlash);
		if (yyyymmddMatch) {
			const year = yyyymmddMatch[1];
			const month = yyyymmddMatch[2].padStart(2, '0');
			const day = yyyymmddMatch[3].padStart(2, '0');
			const result = `${year}-${month}-${day}`;
			// console.log('YYYY/MM/DD format result:', result);
			return result;
		}

		// Handle ISO date strings (with time)
		if (trimmed.includes('T') || trimmed.includes(' ')) {
			const dateOnly = trimmed.split('T')[0].split(' ')[0];
			if (dateOnly.match(/^\d{4}-\d{2}-\d{2}$/)) {
				// console.log('ISO date string result:', dateOnly);
				return dateOnly;
			}
		}

		// Last resort: try to parse manually without using Date constructor
		const parts = trimmed.split(/[-\/\.]/);
		if (parts.length === 3) {
			const nums = parts.map((p) => parseInt(p, 10));

			// Determine which is year, month, day based on values
			let year, month, day;

			if (nums[0] > 31) {
				// First number is year: YYYY-MM-DD
				year = nums[0];
				month = nums[1];
				day = nums[2];
			} else if (nums[2] > 31) {
				// Last number is year: DD-MM-YYYY or MM-DD-YYYY
				// Assume DD-MM-YYYY if first number <= 12, otherwise MM-DD-YYYY
				if (nums[0] <= 12 && nums[1] <= 12) {
					// Ambiguous, default to DD-MM-YYYY
					day = nums[0];
					month = nums[1];
				} else if (nums[0] <= 12) {
					// First is month: MM-DD-YYYY
					month = nums[0];
					day = nums[1];
				} else {
					// Second is month: DD-MM-YYYY
					day = nums[0];
					month = nums[1];
				}
				year = nums[2];
			}

			// Validate the parsed values
			if (year >= 1900 && year <= 2100 && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
				const result = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
				// console.log('Manual parsing result:', result);
				return result;
			}
		}

		// console.log('Could not parse string date:', trimmed);
	}

	// console.log('Returning empty string for:', excelDate);
	return ''; // Return empty string for invalid dates
};
// Initial template for export
const INITIAL_EXPORT_DATA = [
	{
		'Reference Id': '',
		'Lease Title': '',
		'Lease Type': '',
		'Lessor Name': '',
		'Payment Frequency': '',
		'Lease Start Date (YYYY-MM-DD)': '',
		'Lease Effective Date (YYYY-MM-DD)': '',
		'Rent (From Month)': '',
		'Rent (To Month)': '',
		'Rent Amount': '',
		'Advance (From Month)': '',
		'Advance (To Month)': '',
		'Advance Adjustment Amount': '',
		'Incremental Borrowing Rate': '',
		'Escalation (%)': '',
		'Payment Modality': '',
		'Upfront Lease Payment': '',
		'Initial Direct Cost': '',
		'Security Deposit': '',
		'Cash Incentive': '',
	},
];

// Table column definitions
const TABLE_COLUMNS = [
	{ id: 'referenceId', align: 'center', disablePadding: true, label: 'Reference Id', key: 'Reference Id' },
	{ id: 'leaseTitle', align: 'center', disablePadding: true, label: 'Lease Title', key: 'Lease Title' },
	{ id: 'leaseType', align: 'center', disablePadding: true, label: 'Lease Type', key: 'Lease Type' },
	{ id: 'lessorName', align: 'center', disablePadding: true, label: 'Lessor Name', key: 'Lessor Name' },
	{
		id: 'paymentFrequency',
		align: 'center',
		disablePadding: true,
		label: 'Payment Frequency',
		key: 'Payment Frequency',
	},
	{
		id: 'leaseStartDate',
		align: 'center',
		disablePadding: true,
		label: 'Lease Start Date (YYYY-MM-DD)',
		key: 'Lease Start Date (YYYY-MM-DD)',
	},
	{
		id: 'leaseEffectiveDate',
		align: 'center',
		disablePadding: true,
		label: 'Lease Effective Date (YYYY-MM-DD)',
		key: 'Lease Effective Date (YYYY-MM-DD)',
	},
	{
		id: 'rentFromMonth',
		align: 'center',
		disablePadding: true,
		label: 'Rent (From Month)',
		key: 'Rent (From Month)',
	},
	{ id: 'rentToMonth', align: 'center', disablePadding: true, label: 'Rent (To Month)', key: 'Rent (To Month)' },
	{ id: 'rentAmount', align: 'center', disablePadding: true, label: 'Rent Amount', key: 'Rent Amount' },
	{
		id: 'advanceFromMonth',
		align: 'center',
		disablePadding: true,
		label: 'Advance (From Month)',
		key: 'Advance (From Month)',
	},
	{
		id: 'AdvanceToMonth',
		align: 'center',
		disablePadding: true,
		label: 'Advance (To Month)',
		key: 'Advance (To Month)',
	},
	{
		id: 'advanceAdjustmentAmount',
		align: 'center',
		disablePadding: true,
		label: 'Advance Adjustment Amount',
		key: 'Advance Adjustment Amount',
	},
	{
		id: 'internalBorrowingRate',
		align: 'center',
		disablePadding: true,
		label: 'Incremental Borrowing Rate',
		key: 'Incremental Borrowing Rate',
	},
	{ id: 'escalation', align: 'center', disablePadding: true, label: 'Escalation (%)', key: 'Escalation (%)' },
	{
		id: 'paymentModality',
		align: 'center',
		disablePadding: true,
		label: 'Payment Modality',
		key: 'Payment Modality',
	},
	{
		id: 'upfrontLeasePayment',
		align: 'center',
		disablePadding: true,
		label: 'Upfront Lease Payment',
		key: 'Upfront Lease Payment',
	},
	{
		id: 'initialDirectCost',
		align: 'center',
		disablePadding: true,
		label: 'Initial Direct Cost',
		key: 'Initial Direct Cost',
	},
	{
		id: 'securityDeposit',
		align: 'center',
		disablePadding: true,
		label: 'Security Deposit',
		key: 'Security Deposit',
	},
	{ id: 'cashIncentive', align: 'center', disablePadding: true, label: 'Cash Incentive', key: 'Cash Incentive' },
	{ id: 'lrmAction', align: 'center', disablePadding: true, label: 'Action', key: 'Action' },
];

// Guidelines data for the second sheet
const GUIDELINES_DATA = [
	['LEASE BULK UPLOAD GUIDELINES'],
	[''],
	['FIELD VALIDATIONS:'],
	[''],
	['1. Reference Id', 'Required - Unique identifier for each lease'],
	['2. Lease Title', 'Required - Name/title of the lease'],
	['3. Lease Type', 'Required - Type of lease'],
	['4. Lessor Name', 'Required - Name of the lessor'],
	['5. Payment Frequency', 'Required - Must be "Monthly" or "Quarterly"'],
	['6. Lease Start Date', 'Required - Format: YYYY-MM-DD'],
	['7. Lease Effective Date', 'Required - Format: YYYY-MM-DD'],
	['8. Rent (From Month)', 'Required - Numeric value or "-" if not applicable'],
	['9. Rent (To Month)', 'Required - Numeric value or "-" if not applicable'],
	['10. Rent Amount', 'Required - Numeric value or "-" if not applicable'],
	['11. Advance (From Month)', 'Required - Numeric value or "-" if not applicable'],
	['12. Advance (To Month)', 'Required - Numeric value or "-" if not applicable'],
	['13. Advance Adjustment Amount', 'Required - Numeric value or "-" if not applicable'],
	['14. Incremental Borrowing Rate', 'Required - Numeric value (percentage)'],
	['15. Escalation (%)', 'Required - Numeric value (percentage)'],
	['16. Payment Modality', 'Required - "Advance Basis" or "Accrual Basis"'],
	['17. Upfront Lease Payment', 'Optional - Numeric value (default: 0)'],
	['18. Initial Direct Cost', 'Optional - Numeric value (default: 0)'],
	['19. Security Deposit', 'Optional - Numeric value (default: 0)'],
	['20. Cash Incentive', 'Optional - Numeric value (default: 0)'],
	[''],
	['BUSINESS RULES:'],
	[''],
	['1. Sequential Periods:', 'Rent and Advance periods must be sequential within each effective date group'],
	['2. From <= To Months:', 'From Month must be less than or equal to To Month in the same row'],
	['3. Consistency:', 'Fields like Lease Title, Lessor Name, Payment Frequency must be consistent within the same effective date group'],
	['4. Effective Date Range:', 'Effective Date must be within the lease period (Start Date to End Date)'],
	['5. Effective Date Order:', 'Multiple effective dates for the same Reference Id must be in chronological order'],
	['6. Rent vs Advance:', 'Max Rent (To Month) must be >= Max Advance (To Month)'],
	['7. Total Amounts:', 'Total Rent Amount must be >= Total Advance Adjustment Amount'],
	[''],
	['DATA ENTRY TIPS:'],
	[''],
	['• Use "-" for fields that are not applicable'],
	['• Ensure dates are in YYYY-MM-DD format'],
	['• All numeric fields should contain only numbers'],
	['• Payment Frequency: Use exact values "Monthly" or "Quarterly"'],
	['• Payment Modality: Use exact values "Advance Basis" or "Accrual Basis"'],
	['• For multiple effective dates, group rows by Reference Id and Effective Date'],
	[''],
	['EXAMPLE SCENARIOS:'],
	[''],
	['Scenario 1: New Lease Creation'],
	['- Single effective date (usually lease start date)'],
	['- All required fields must be filled'],
	[''],
	['Scenario 2: Lease Modification'],
	['- Multiple effective dates for same Reference Id'],
	['- Each effective date represents a change in lease terms'],
	['- Effective dates must be in chronological order'],
	[''],
	['ERROR RESOLUTION:'],
	[''],
	['• Red borders indicate validation errors'],
	['• Click "Show Errors" button to see detailed error messages'],
	['• Fix all errors before submitting'],
	['• Download this template again if needed'],
];

// Function to export Excel with multiple sheets
const exportExcelFileWithGuidelines = (templateData, fileName) => {
	const wb = XLSX.utils.book_new();

	// Create the template sheet
	const templateWs = XLSX.utils.json_to_sheet(templateData);
	const columnWidths = Array(Object.keys(templateData[0]).length).fill({ wch: 20 });
	templateWs['!cols'] = columnWidths;
	XLSX.utils.book_append_sheet(wb, templateWs, 'Template');

	// Create the guidelines sheet
	const guidelinesWs = XLSX.utils.aoa_to_sheet(GUIDELINES_DATA);

	// Set column widths for guidelines sheet
	guidelinesWs['!cols'] = [
		{ wch: 30 }, // Field/Topic column
		{ wch: 80 }, // Description column
	];

	// Style the guidelines sheet
	const range = XLSX.utils.decode_range(guidelinesWs['!ref']);
	for (let R = range.s.r; R <= range.e.r; ++R) {
		for (let C = range.s.c; C <= range.e.c; ++C) {
			const cellAddress = { c: C, r: R };
			const cellRef = XLSX.utils.encode_cell(cellAddress);
			if (!guidelinesWs[cellRef]) continue;

			// Initialize cell style
			guidelinesWs[cellRef].s = guidelinesWs[cellRef].s || {};

			// Style the main title
			if (R === 0) {
				guidelinesWs[cellRef].s.font = { bold: true, sz: 16 };
				guidelinesWs[cellRef].s.alignment = { horizontal: 'center' };
			}
			// Style section headers
			else if (
				GUIDELINES_DATA[R] &&
				GUIDELINES_DATA[R][0] &&
				(GUIDELINES_DATA[R][0].includes('VALIDATIONS:') ||
					GUIDELINES_DATA[R][0].includes('BUSINESS RULES:') ||
					GUIDELINES_DATA[R][0].includes('DATA ENTRY TIPS:') ||
					GUIDELINES_DATA[R][0].includes('EXAMPLE SCENARIOS:') ||
					GUIDELINES_DATA[R][0].includes('ERROR RESOLUTION:'))
			) {
				guidelinesWs[cellRef].s.font = { bold: true, sz: 12 };
				guidelinesWs[cellRef].s.fill = { fgColor: { rgb: 'E6E6FA' } };
			}
			// Style field names (numbered items)
			else if (GUIDELINES_DATA[R] && GUIDELINES_DATA[R][0] && /^\d+\./.test(GUIDELINES_DATA[R][0])) {
				guidelinesWs[cellRef].s.font = { bold: true };
			}
		}
	}

	XLSX.utils.book_append_sheet(wb, guidelinesWs, 'Guidelines');

	// Generate and download the file
	const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
	const blob = new Blob([wbout], { type: 'application/octet-stream' });
	const url = window.URL.createObjectURL(blob);
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = fileName;
	anchor.click();
	window.URL.revokeObjectURL(url);
};

// Helper functions
// Updated helper function to transform errors for better display in modal
const transformErrors = (errorObj, index) => {
	// Filter out 'valid' flag which shouldn't be displayed
	if (errorObj.valid !== undefined) {
		const { valid, ...rest } = errorObj;
		errorObj = rest;
	}

	// Create a more structured error format for display
	return Object.entries(errorObj).map(([field, message]) => ({
		DataIndex: index,
		field: field.startsWith('Error_') ? 'Validation Error' : field,
		message: message, // Message already includes row number from validation
	}));
};

const formatDecimal = (number) => {
	return Number(number).toFixed(2);
};

const formatDate = (dateStr) => {
	if (typeof dateStr !== 'string') return '';
	let [year, month, day] = dateStr.split('-').map((num) => num.padStart(2, '0'));
	return `${year}-${month}-${day}`;
};

const formatEffectiveDate = (dateStr) => {
	if (typeof dateStr !== 'string') return '';
	let [year, month, day] = dateStr.split('-').map((num) => num.padStart(2, '0'));
	if (+day < 10 && !day.includes('0')) day = '0' + day;
	return `${year}-${month}-${day}`;
};

const calculateMonthDifference = (effectiveDateInput, startDateInput) => {
	const effectiveDate = dayjs(effectiveDateInput);
	const startDate = dayjs(startDateInput);

	let monthDifference = (effectiveDate.year() - startDate.year()) * 12 + (effectiveDate.month() - startDate.month());
	monthDifference += 1;

	// Ensure non-negative
	if (monthDifference < 0) {
		monthDifference = 0;
	}

	return monthDifference;
};

const getDateParts = (date) => {
	if (!date) return { day: '', month: '', year: '' };
	const [year, month, day] = date.split('-').map((num) => num.padStart(2, '0'));
	return { day, month, year };
};

// Function to process lease data for a group of records
const processLeaseData = (data) => {
	// Helper function to format amounts
	const formatAmount = (amount) => {
		return amount.toLocaleString('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	};

	// Find max lease term from the data
	const maxLeaseTerm = data.reduce((max, item) => {
		const rentToMonth = item['Rent (To Month)'] === '-' ? 0 : Number(item['Rent (To Month)']);
		const advanceToMonth = item['Advance (To Month)'] === '-' ? 0 : Number(item['Advance (To Month)']);
		return Math.max(max, rentToMonth, advanceToMonth);
	}, 0);

	// Use the calculated maxLeaseTerm
	const leaseTerm = maxLeaseTerm;

	// Process advance data
	const inputChangeAdvanceAmounts = new Array(leaseTerm).fill(0);
	const advanceAmountList = [];
	let totalAdvanceAmount = 0;
	let maxAdvanceToMonth = 0;

	data.forEach((item) => {
		if (item['Advance (From Month)'] !== '-' && item['Advance (To Month)'] !== '-' && item['Advance Adjustment Amount'] !== '-') {
			const from = Number(item['Advance (From Month)']);
			const to = Number(item['Advance (To Month)']);
			const amount = Number(item['Advance Adjustment Amount']);

			// Update max advance month
			maxAdvanceToMonth = Math.max(maxAdvanceToMonth, to);

			// Add to total
			totalAdvanceAmount += amount;

			// Fill value array
			for (let month = from; month <= to; month++) {
				if (month - 1 < leaseTerm) {
					inputChangeAdvanceAmounts[month - 1] = amount;
				}
			}

			// Add to structured array
			advanceAmountList.push({
				from: from,
				to: to.toString(),
				amount: formatAmount(amount),
			});
		}
	});

	// Process rent data
	const inputChangeGrossRents = new Array(leaseTerm).fill(0);
	const grossRentList = [];
	let totalRentAmount = 0;

	data.forEach((item) => {
		if (item['Rent (From Month)'] !== '-' && item['Rent (To Month)'] !== '-' && item['Rent Amount'] !== '-') {
			const from = Number(item['Rent (From Month)']);
			const to = Number(item['Rent (To Month)']);
			const amount = Number(item['Rent Amount']);

			// Add to total
			totalRentAmount += amount;

			// Fill value array
			for (let month = from; month <= to; month++) {
				if (month - 1 < leaseTerm) {
					inputChangeGrossRents[month - 1] = amount;
				}
			}

			// Add to structured array
			grossRentList.push({
				from: from,
				to: to.toString(),
				amount: formatAmount(amount),
				remarks: '',
			});
		}
	});

	// Sort and remove duplicates
	advanceAmountList.sort((a, b) => a.from - b.from);
	grossRentList.sort((a, b) => a.from - b.from);

	const uniqueAdvanceList = advanceAmountList.filter((item, index, self) => index === self.findIndex((t) => t.from === item.from));
	const uniqueRentList = grossRentList.filter((item, index, self) => index === self.findIndex((t) => t.from === item.from));

	return {
		// Advance related outputs
		inputChangeAdvanceAmounts,
		advanceAmountList: uniqueAdvanceList,
		totalAdvanceAmount,
		maxAdvanceToMonth,

		// Rent related outputs
		inputChangeGrossRents,
		grossRentList: uniqueRentList,
		totalRentAmount,

		// Lease term
		maxLeaseTerm,
		leaseTerm, // This is the same as maxLeaseTerm (or 48 if no data)
	};
};

// Function to validate if rent periods within a group are sequential
// const validateSequentialRentPeriods = (items) => {
// 	// First, sort by From Month
// 	const rentItems = items
// 		.filter((item) => item['Rent (From Month)'] !== '-' && item['Rent (To Month)'] !== '-')
// 		.sort((a, b) => Number(a['Rent (From Month)']) - Number(b['Rent (From Month)']));

// 	const advanceItems = items
// 		.filter((item) => item['Advance (From Month)'] !== '-' && item['Advance (To Month)'] !== '-')
// 		.sort((a, b) => Number(a['Advance (From Month)']) - Number(b['Advance (From Month)']));

// 	const errors = [];

// 	// Check each rent item for From <= To in the same row
// 	for (let i = 0; i < rentItems.length; i++) {
// 		const current = rentItems[i];
// 		const fromMonth = Number(current['Rent (From Month)']);
// 		const toMonth = Number(current['Rent (To Month)']);

// 		// Check that From <= To within the same row
// 		if (fromMonth > toMonth) {
// 			errors.push({
// 				rowIndex: current['Data No.'],
// 				originalRow: current,
// 				message: `Rent (From Month) ${fromMonth} must be less than or equal to Rent (To Month) ${toMonth}`,
// 			});
// 		}
// 	}

// 	// Check for sequence breaks between rent rows
// 	for (let i = 0; i < rentItems.length - 1; i++) {
// 		const current = rentItems[i];
// 		const next = rentItems[i + 1];

// 		const currentToMonth = Number(current['Rent (To Month)']);
// 		const nextFromMonth = Number(next['Rent (From Month)']);

// 		if (currentToMonth + 1 !== nextFromMonth) {
// 			// Only flag the next row as having the error
// 			errors.push({
// 				rowIndex: next['Data No.'],
// 				originalRow: next,
// 				message: `Rent sequence break: expected ${currentToMonth + 1} but got ${nextFromMonth}`,
// 			});
// 		}
// 	}

// 	// Check each advance item for From <= To in the same row
// 	for (let i = 0; i < advanceItems.length; i++) {
// 		const current = advanceItems[i];
// 		const fromMonth = Number(current['Advance (From Month)']);
// 		const toMonth = Number(current['Advance (To Month)']);

// 		// Check that From <= To within the same row
// 		if (fromMonth > toMonth) {
// 			errors.push({
// 				rowIndex: current['Data No.'],
// 				originalRow: current,
// 				message: `Advance (From Month) ${fromMonth} must be less than or equal to Advance (To Month) ${toMonth}`,
// 			});
// 		}
// 	}

// 	// Check for sequence breaks between advance rows
// 	for (let i = 0; i < advanceItems.length - 1; i++) {
// 		const current = advanceItems[i];
// 		const next = advanceItems[i + 1];

// 		const currentToMonth = Number(current['Advance (To Month)']);
// 		const nextFromMonth = Number(next['Advance (From Month)']);

// 		if (currentToMonth + 1 !== nextFromMonth) {
// 			// Only flag the next row as having the error
// 			errors.push({
// 				rowIndex: next['Data No.'],
// 				originalRow: next,
// 				message: `Advance sequence break: expected ${currentToMonth + 1} but got ${nextFromMonth}`,
// 			});
// 		}
// 	}

// 	return errors;
// };

// Function to validate consistency within each effective date group
const validateConsistentFields = (items) => {
	// Skip validation if less than 2 items
	if (items.length < 2) {
		return [];
	}

	const errors = [];
	const fieldsToCheck = [
		'Lease Title',
		'Lease Type',
		'Lessor Name',
		'Payment Frequency',
		'Lease Start Date (YYYY-MM-DD)',
		'Incremental Borrowing Rate',
		'Escalation (%)',
	];

	// Use the first item as reference
	const referenceItem = items[0];

	// For each item, check against the reference item
	for (let i = 1; i < items.length; i++) {
		const currentItem = items[i];

		// For each field to check
		fieldsToCheck.forEach((field) => {
			let referenceValue = referenceItem[field];
			let currentValue = currentItem[field];

			// Special handling for dates
			if (field === 'Lease Start Date (YYYY-MM-DD)') {
				referenceValue = parseAndFormatExcelDate(referenceValue);
				currentValue = parseAndFormatExcelDate(currentValue);
			}

			// Compare values
			if (referenceValue !== currentValue) {
				// Create a unique identifier for the row with the inconsistency
				errors.push({
					rowIndex: currentItem['Data No.'],
					referenceId: currentItem['Reference Id'],
					effectiveDate: parseAndFormatExcelDate(currentItem['Lease Effective Date (YYYY-MM-DD)']),
					fromMonth: currentItem['Rent (From Month)'],
					toMonth: currentItem['Rent (To Month)'],
					message: `${field} must be consistent within the same effective date group. Expected: ${referenceValue}`,
				});
			}
		});
	}

	return errors;
};

// Memoized table components
const OptimizedTableCell = memo(({ column, lrm, getCellStyle, getCellContent }) => {
	const align = column.key === 'Lease Title' || column.key === 'Lessor Name' ? 'left' : 'center';

	if (column.key === 'Action') {
		return <TableCell align={align}>{getCellContent(column.key, null, lrm)}</TableCell>;
	}

	return (
		<TableCell align={align}>
			<div
				style={getCellStyle(column.key, lrm[column.key], lrm)}>{getCellContent(column.key, lrm[column.key], lrm)}</div>
		</TableCell>
	);
});

// Update the getRowStyle function to only separate reference ID groups
const getRowStyle = (lrm, tableData, index) => {
	// Get reference ID
	const referenceId = lrm['Reference Id'];

	// Get next row
	const nextRow = index < tableData.length - 1 ? tableData[index + 1] : null;

	// Check if this row ends a reference ID group
	const isRefIdEnd = !nextRow || nextRow['Reference Id'] !== referenceId;

	// Check if this is the last row in the entire table
	const isLastRow = index === tableData.length - 1;

	// Initialize style object
	const style = {};

	// Only add bottom borders between reference ID groups
	if (isRefIdEnd && !isLastRow) {
		// This is the last row of a reference ID group, but not the last row in the table
		style.borderBottom = '1px solid #000000';
	}

	// Subtle background alternation for better readability
	if (lrm.groupId % 2 === 0) {
		style.backgroundColor = '#f7fbff'; // Light gray background for even groups
	}

	return style;
};

// Update the OptimizedTableRow component to use the new styling
const OptimizedTableRow = memo(({ lrm, index, columns, getCellStyle, getCellContent, tableData }) => {
	const rowStyle = getRowStyle(lrm, tableData, index);

	return (
		<TableRow
			hover
			role="checkbox"
			sx={{
				'&:last-child td, &:last-child th': { border: 0 },
				...rowStyle,
				// Force border to be visible and override any conflicting styles
				...(rowStyle.borderBottom && {
					'& td': {
						borderBottom: rowStyle.borderBottom + ' !important',
					},
				}),
			}}
			tabIndex={-1}
		>
			{columns.map((column, colIndex) => (
				<OptimizedTableCell
					key={`${index}-${colIndex}`}
					column={column}
					lrm={lrm}
					getCellStyle={getCellStyle}
					getCellContent={getCellContent}
				/>
			))}
		</TableRow>
	);
});

// Function to prepare a change object based on lease data
// const prepareChangeObject = (groupData, startDate, description = 'Initial Rent') => {
// 	const { inputChangeAdvanceAmounts, totalAdvanceAmount, maxAdvanceToMonth, inputChangeGrossRents, totalRentAmount, maxLeaseTerm } =
// 		processLeaseData(groupData);
//
// 	const effectiveDate = parseAndFormatExcelDate(groupData[0]['Lease Effective Date (YYYY-MM-DD)']);
//
// 	return {
// 		inputChangeMonth: calculateMonthDifference(effectiveDate, startDate),
// 		inputChangeLeaseTerm: groupData[0]['Payment Frequency']?.toLowerCase() === 'quarterly' ? Number(maxLeaseTerm) / 3 : Number(maxLeaseTerm),
// 		inputChangeGrossAmount: totalRentAmount,
// 		inputChangeDiscountRate: String(groupData[0]['Incremental Borrowing Rate']),
// 		inputChangeEscalation: String(groupData[0]['Escalation (%)']),
// 		paymentFrequency:
// 			groupData[0]['Payment Frequency']?.toLowerCase() === 'monthly'
// 				? 'Monthly'
// 				: groupData[0]['Payment Frequency']?.toLowerCase() === 'quarterly'
// 					? 'Quarterly'
// 					: '',
// 		paymentTime:
// 			groupData[0]['Payment Modality']?.toLowerCase() === 'advance basis'
// 				? 'Start'
// 				: groupData[0]['Payment Modality']?.toLowerCase() === 'accrual basis'
// 					? 'End'
// 					: '',
// 		inputChangeAdvance: inputChangeAdvanceAmounts?.reduce((sum, item) => sum + Number(item), 0),
// 		inputChangeAmortizationPeriod: String(maxAdvanceToMonth),
// 		inputChangeEffectiveDate: formatEffectiveDate(effectiveDate),
// 		inputChangeAdvanceAmounts,
// 		inputChangeGrossRents,
// 		inputChangeDescription: description,
// 		// Additional fields for proper lease calculation
// 		upfrontLeasePayment: String(groupData[0]['Upfront Lease Payment'] || 0),
// 		initialDirectCost: String(groupData[0]['Initial Direct Cost'] || 0),
// 		securityDeposit: String(groupData[0]['Security Deposit'] || 0),
// 		cashIncentiveAmount: String(groupData[0]['Cash Incentive'] || 0),
// 	};
// };
function resizeArraysConcise(arr1, arr2, max, fillValue = 0) {
	const resize = (arr) => {
		const sliced = arr.slice(0, max);
		const paddingLength = Math.max(0, max - sliced.length);
		return sliced.concat(Array(paddingLength).fill(fillValue));
	};

	return [resize(arr1), resize(arr2)];
}

const prepareChangeObject = (groupData, startDate, description = 'Initial Rent', maxLeaseTermOverall = null) => {

	const {
		inputChangeAdvanceAmounts,
		totalAdvanceAmount,
		maxAdvanceToMonth,
		inputChangeGrossRents,
		totalRentAmount,
		maxLeaseTerm,
	} =
		processLeaseData(groupData);

	const effectiveDate = parseAndFormatExcelDate(groupData[0]['Lease Effective Date (YYYY-MM-DD)']);

	// Use the overall max lease term if provided
	const termToUse = groupData[groupData?.length - 1]['Rent (To Month)'];

	// For the initial change, extend arrays to max lease term size
	let finalAdvanceAmounts = inputChangeAdvanceAmounts;
	let finalGrossRents = inputChangeGrossRents;

	if (finalAdvanceAmounts.length < groupData[groupData?.length - 1]['Rent (To Month)']) {
		// Extend arrays to max lease term size
		finalAdvanceAmounts = [
			...inputChangeAdvanceAmounts,
			...new Array(groupData[groupData?.length - 1]['Rent (To Month)'] - inputChangeAdvanceAmounts.length).fill(0),
		];
		finalGrossRents = [...inputChangeGrossRents];
	}
	const [finalRents, finalAdvances] = resizeArraysConcise(finalGrossRents, finalAdvanceAmounts, Number(termToUse));
	return {
		inputChangeMonth: calculateMonthDifference(effectiveDate, startDate),
		inputChangeLeaseTerm: Number(termToUse),
		inputChangeGrossAmount: 0,
		inputChangeDiscountRate: String(groupData[0]['Incremental Borrowing Rate']),
		inputChangeEscalation: String(groupData[0]['Escalation (%)']),
		paymentFrequency:
			groupData[0]['Payment Frequency']?.toLowerCase() === 'monthly'
				? 'Monthly'
				: groupData[0]['Payment Frequency']?.toLowerCase() === 'quarterly'
					? 'Quarterly'
					: '',
		paymentTime:
			groupData[0]['Payment Modality']?.toLowerCase() === 'advance basis'
				? 'Start'
				: groupData[0]['Payment Modality']?.toLowerCase() === 'accrual basis'
					? 'End'
					: '',
		inputChangeAdvance: finalAdvanceAmounts?.reduce((sum, item) => sum + Number(item), 0),
		inputChangeAmortizationPeriod: String(maxAdvanceToMonth),
		inputChangeEffectiveDate: utcConverter(dayjs(effectiveDate)),
		inputChangeAdvanceAmounts: finalAdvances,
		inputChangeGrossRents: finalRents,
		inputChangeDescription: description,
		// Additional fields for proper lease calculation
		upfrontLeasePayment: String(groupData[0]['Upfront Lease Payment'] || 0),
		initialDirectCost: String(groupData[0]['Initial Direct Cost'] || 0),
		securityDeposit: String(groupData[0]['Security Deposit'] || 0),
		cashIncentiveAmount: String(groupData[0]['Cash Incentive'] || 0),
	};
};
// const compareAndRemoveDuplicates = (inputArray) => {
// 	// Check if the array has at least 2 elements
// 	if (!Array.isArray(inputArray) || inputArray.length < 2) {
// 		return {
// 			data: inputArray,
// 			isChanged: false,
// 		};
// 	}

// 	// Get the last two elements
// 	const lastElement = inputArray[inputArray.length - 1];
// 	const secondLastElement = inputArray[inputArray.length - 2];

// 	// Function to normalize objects for comparison
// 	const normalizeForComparison = (arr) => {
// 		if (!Array.isArray(arr)) return arr;

// 		return arr.map((item) => {
// 			// Create a deep copy of the item
// 			const normalizedItem = JSON.parse(JSON.stringify(item));

// 			// Normalize each inner object
// 			return normalizedItem.map((obj) => {
// 				const result = { ...obj };

// 				// Normalize amount field if it exists - remove commas and standardize format
// 				if (obj.amount !== undefined && typeof obj.amount === 'string') {
// 					// Remove commas and convert to a number, then format back to string with 2 decimal places
// 					const numericValue = parseFloat(obj.amount.replace(/,/g, ''));
// 					if (!isNaN(numericValue)) {
// 						result.amount = numericValue.toFixed(2);
// 					}
// 				}

// 				return result;
// 			});
// 		});
// 	};

// 	// Normalize both arrays for comparison
// 	const normalizedLast = normalizeForComparison([lastElement])[0];
// 	const normalizedSecondLast = normalizeForComparison([secondLastElement])[0];

// 	// Deep compare the normalized elements
// 	const areEqual = JSON.stringify(normalizedLast) === JSON.stringify(normalizedSecondLast);

// 	if (areEqual) {
// 		// If they are the same, remove the last element
// 		const modifiedArray = inputArray.slice(0, -1);
// 		return {
// 			data: modifiedArray,
// 			isChanged: false,
// 		};
// 	} else {
// 		// If they are different, return the original array
// 		return {
// 			data: inputArray,
// 			isChanged: true,
// 		};
// 	}
// };

// Main component
const LeaseBulkUploadForTestBed = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const { state } = useLocation();

	// UI state management
	const [uiState, setUiState] = useState({
		show: false,
		showModal: false,
		fileSubmitButton: false,
		validationFailed: false, // New state to track validation failure
	});

	const validateRentAdvanceMonths = (items) => {
		const errors = [];

		// Calculate max Rent (To Month)
		const rentToMonths = items.filter((item) => item['Rent (To Month)'] !== '-').map((item) => Number(item['Rent (To Month)']));

		const maxRentToMonth = rentToMonths.length > 0 ? Math.max(...rentToMonths) : 0;

		// Calculate max Advance (To Month)
		const advanceToMonths = items.filter((item) => item['Advance (To Month)'] !== '-').map((item) => Number(item['Advance (To Month)']));

		const maxAdvanceToMonth = advanceToMonths.length > 0 ? Math.max(...advanceToMonths) : 0;

		// Check if max Rent (To Month) < max Advance (To Month) and there's valid advance data
		if (maxRentToMonth < maxAdvanceToMonth && maxAdvanceToMonth > 0) {
			errors.push({
				rowIndex: items[0]['Data No.'],
				originalRow: items[0],
				message: `Max Rent (To Month) ${maxRentToMonth} must be greater than or equal to max Advance (To Month) ${maxAdvanceToMonth}`,
			});
		}

		return errors;
	};
	const validateEffectiveDateRange = (items, allItems) => {
		const errors = [];

		// Skip validation if this is the only group
		if (items.length === 0 || allItems.length === items.length) {
			return errors;
		}

		// Get the effective date for this group
		const effectiveDate = parseAndFormatExcelDate(items[0]['Lease Effective Date (YYYY-MM-DD)']);
		const effectiveDateObj = dayjs(effectiveDate);

		// Find the initial group (first effective date) with the same reference ID
		const referenceId = items[0]['Reference Id'];
		const initialGroup = allItems
			.filter((item) => item['Reference Id'] === referenceId)
			.sort((a, b) => {
				const aDate = parseAndFormatExcelDate(a['Lease Effective Date (YYYY-MM-DD)']);
				const bDate = parseAndFormatExcelDate(b['Lease Effective Date (YYYY-MM-DD)']);
				return dayjs(aDate).diff(dayjs(bDate));
			});

		if (initialGroup.length > 0) {
			const initialItem = initialGroup[0];
			const leaseStartDate = parseAndFormatExcelDate(initialItem['Lease Start Date (YYYY-MM-DD)']);

			// Get max lease term from all items in the same reference ID
			const leaseTerm = Math.max(
				...initialGroup.flatMap((item) => [
					item['Rent (To Month)'] !== '-' ? Number(item['Rent (To Month)']) : 0,
					item['Advance (To Month)'] !== '-' ? Number(item['Advance (To Month)']) : 0,
				]),
			);

			const leaseStartDateObj = dayjs(leaseStartDate);
			const leaseEndDateObj = leaseStartDateObj.add(leaseTerm, 'month');

			// Check if effectiveDate is within valid range
			if (effectiveDateObj.isBefore(leaseStartDateObj) || effectiveDateObj.isAfter(leaseEndDateObj)) {
				errors.push({
					rowIndex: items[0]['Data No.'],
					originalRow: items[0],
					message: `Effective Date must be between Lease Period (${leaseStartDate} to ${leaseEndDateObj.format('YYYY-MM-DD')})`,
				});
			}
		}

		return errors;
	};
	const validateEffectiveDateOrder = (groups) => {
		const errors = [];

		if (groups.length <= 1) {
			return errors;
		}

		// Group the effective date groups by Reference Id
		const refIdGroups = _.groupBy(groups, (group) => group[0]['Reference Id']);

		// For each reference ID
		Object.keys(refIdGroups).forEach((refId) => {
			const refGroups = refIdGroups[refId];

			// Skip if only one effective date
			if (refGroups.length <= 1) {
				return;
			}

			// Sort groups by effective date
			const sortedGroups = [...refGroups].sort((a, b) => {
				const aDate = parseAndFormatExcelDate(a[0]['Lease Effective Date (YYYY-MM-DD)']);
				const bDate = parseAndFormatExcelDate(b[0]['Lease Effective Date (YYYY-MM-DD)']);
				return dayjs(aDate).diff(dayjs(bDate));
			});

			// Check each consecutive pair
			for (let i = 0; i < sortedGroups.length - 1; i++) {
				const currentGroup = sortedGroups[i];
				const nextGroup = sortedGroups[i + 1];

				const currentDate = parseAndFormatExcelDate(currentGroup[0]['Lease Effective Date (YYYY-MM-DD)']);
				const nextDate = parseAndFormatExcelDate(nextGroup[0]['Lease Effective Date (YYYY-MM-DD)']);

				// Check if dates are equal or in wrong order
				if (dayjs(currentDate).isAfter(dayjs(nextDate)) || currentDate === nextDate) {
					errors.push({
						rowIndex: nextGroup[0]['Data No.'],
						originalRow: nextGroup[0],
						message: `Effective Date ${nextDate} must be after previous group's Effective Date ${currentDate}`,
					});
				}
			}
		});

		return errors;
	};
	const validateRentVsAdvance = (items) => {
		const errors = [];

		// Calculate total Rent Amount
		const totalRentAmount = items.filter((item) => item['Rent Amount'] !== '-').reduce((sum, item) => sum + Number(item['Rent Amount']), 0);

		// Calculate total Advance Adjustment Amount
		const totalAdvanceAmount = items
			.filter((item) => item['Advance Adjustment Amount'] !== '-')
			.reduce((sum, item) => sum + Number(item['Advance Adjustment Amount']), 0);

		// Check if total Rent Amount < total Advance Adjustment Amount
		if (totalRentAmount < totalAdvanceAmount && totalAdvanceAmount > 0) {
			errors.push({
				rowIndex: items[0]['Data No.'],
				originalRow: items[0],
				message: `Total Rent Amount (${totalRentAmount}) must be greater than or equal to total Advance Adjustment Amount (${totalAdvanceAmount})`,
			});
		}

		return errors;
	};
	// State setters with useCallback for better performance
	const setShowModal = useCallback((value) => {
		setUiState((prev) => ({ ...prev, showModal: value }));
	}, []);

	const setShow = useCallback((value) => {
		setUiState((prev) => ({ ...prev, show: value }));
	}, []);

	const setFileSubmitButton = useCallback((value) => {
		setUiState((prev) => ({ ...prev, fileSubmitButton: value }));
	}, []);

	const setValidationFailed = useCallback((value) => {
		setUiState((prev) => ({ ...prev, validationFailed: value }));
	}, []);

	// Data state
	const [data, setData] = useState({
		excelData: [],
		excelTable: [],
		modalInfo: null,
		validationErrors: [], // To store validation errors
		emptyFileError: false, // New state to track empty file error
	});

	// State setters with useCallback
	const setExcelTable = useCallback((value) => {
		setData((prev) => ({ ...prev, excelTable: value }));
	}, []);

	const setValidationErrors = useCallback((value) => {
		setData((prev) => ({ ...prev, validationErrors: value }));
	}, []);

	// API hooks
	const [uploadBulkIdentityCase, {
		error: errorData,
		isSuccess: isBulkCaseSuccess,
		isError: isBulkCaseError,
	}] = useGetAllIdentityCaseMutation();

	// Effect to check form validity
	useEffect(() => {
		// Check if every item's remark is valid.
		const allValid = data.excelTable.every((item) => {
			return item['Remarks'].valid;
		});

		// Set the submit button state based on that check.
		setFileSubmitButton(!allValid);
	}, [data.excelTable]);

	// Effect for API success/error handling
	useEffect(() => {
		if (isBulkCaseSuccess) {
			toast.success('Lease records processed successfully!', toastConfig);
			navigate(-1);
		} else if (isBulkCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isBulkCaseSuccess, isBulkCaseError, errorData, navigate]);

	// Function to enhance validation of data
	const getModifiedData = useCallback((data) => {
		// Create a mapping from Lease Id to a sequential Data No.
		const leaseIdToDataNo = {};
		let dataNoCounter = 1;

		// First pass: assign data numbers and basic validation
		const processedData = data.map((item) => {
			const leaseId = item?.['Reference Id'];

			// Assign a new Data No. if this Lease Id is encountered for the first time.
			if (!leaseIdToDataNo.hasOwnProperty(leaseId)) {
				leaseIdToDataNo[leaseId] = dataNoCounter;
				dataNoCounter++;
			}

			// Build the remarks object with keys for each error field.
			let remarks = {};

			// Required fields that must be non-empty for every row:
			if (item?.['Payment Frequency'] === '' || item?.['Payment Frequency'] === undefined) {
				remarks['Payment Frequency'] = 'Payment Frequency is required';
			} else if (item?.['Payment Frequency'] !== 'Monthly' && item?.['Payment Frequency'] !== 'Quarterly') {
				remarks['Payment Frequency'] = 'Payment Frequency must be either Monthly or Quarterly';
			}

			if (!item?.['Lease Start Date (YYYY-MM-DD)']) {
				remarks['Lease Start Date (YYYY-MM-DD)'] = 'Lease Start Date (YYYY-MM-DD) is required';
			}

			if (!item?.['Lease Effective Date (YYYY-MM-DD)']) {
				remarks['Lease Effective Date (YYYY-MM-DD)'] = 'Lease Effective Date (YYYY-MM-DD) is required';
			}

			if (item?.['Rent Amount'] === '' || item?.['Rent Amount'] === undefined) {
				remarks['Rent Amount'] = 'Rent Amount is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Rent Amount'])) && item?.['Rent Amount'] !== '-') {
				remarks['Rent Amount'] = 'Rent Amount must be a number';
			}

			if (item?.['Rent (From Month)'] === '' || item?.['Rent (From Month)'] === undefined) {
				remarks['Rent (From Month)'] = 'Rent (From Month) is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Rent (From Month)'])) && item?.['Rent (From Month)'] !== '-') {
				remarks['Rent (From Month)'] = 'Rent (From Month) must be a number';
			}

			if (item?.['Rent (To Month)'] === '' || item?.['Rent (To Month)'] === undefined) {
				remarks['Rent (To Month)'] = 'Rent (To Month) is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Rent (To Month)'])) && item?.['Rent (To Month)'] !== '-') {
				remarks['Rent (To Month)'] = 'Rent (To Month) must be a number';
			}

			if (item?.['Advance (From Month)'] === '' || item?.['Advance (From Month)'] === undefined) {
				remarks['Advance (From Month)'] = 'Advance (From Month) is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Advance (From Month)'])) && item?.['Advance (From Month)'] !== '-') {
				remarks['Advance (From Month)'] = 'Advance (From Month) must be a number';
			}

			if (item?.['Advance (To Month)'] === '' || item?.['Advance (To Month)'] === undefined) {
				remarks['Advance (To Month)'] = 'Advance (To Month) is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Advance (To Month)'])) && item?.['Advance (To Month)'] !== '-') {
				remarks['Advance (To Month)'] = 'Advance (To Month) must be a number';
			}

			if (item?.['Advance Adjustment Amount'] === '' || item?.['Advance Adjustment Amount'] === undefined) {
				remarks['Advance Adjustment Amount'] = 'Advance Adjustment Amount is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Advance Adjustment Amount'])) && item?.['Advance Adjustment Amount'] !== '-') {
				remarks['Advance Adjustment Amount'] = 'Advance Adjustment Amount must be a number';
			}

			if (item?.['Incremental Borrowing Rate'] === '' || item?.['Incremental Borrowing Rate'] === undefined) {
				remarks['Incremental Borrowing Rate'] = 'Incremental Borrowing Rate is required';
			} else if (isNaN(Number(item?.['Incremental Borrowing Rate']))) {
				remarks['Incremental Borrowing Rate'] = 'Incremental Borrowing Rate must be a number';
			}

			if (item?.['Escalation (%)'] === '' || item?.['Escalation (%)'] === undefined) {
				remarks['Escalation (%)'] = 'Escalation (%) is required';
			} else if (isNaN(Number(item?.['Escalation (%)']))) {
				remarks['Escalation (%)'] = 'Escalation (%) must be a number';
			}

			if (item?.['Payment Modality'] === '' || item?.['Payment Modality'] === undefined) {
				remarks['Payment Modality'] = 'Payment Modality is required';
			} else if (
				item?.['Payment Modality']?.toLowerCase() !== 'advance basis' &&
				item?.['Payment Modality']?.toLowerCase() !== 'accrual basis'
			) {
				remarks['Payment Modality'] = 'Payment Modality must be either Advance Basis or Accrual Basis';
			}
			if (
				item?.['Upfront Lease Payment'] !== '' &&
				item?.['Upfront Lease Payment'] !== undefined &&
				isNaN(Number(item?.['Upfront Lease Payment']))
			) {
				remarks['Upfront Lease Payment'] = 'Upfront Lease Payment must be a number';
			}

			if (item?.['Initial Direct Cost'] !== '' && item?.['Initial Direct Cost'] !== undefined && isNaN(Number(item?.['Initial Direct Cost']))) {
				remarks['Initial Direct Cost'] = 'Initial Direct Cost must be a number';
			}

			if (item?.['Security Deposit'] !== '' && item?.['Security Deposit'] !== undefined && isNaN(Number(item?.['Security Deposit']))) {
				remarks['Security Deposit'] = 'Security Deposit must be a number';
			}

			if (item?.['Cash Incentive'] !== '' && item?.['Cash Incentive'] !== undefined && isNaN(Number(item?.['Cash Incentive']))) {
				remarks['Cash Incentive'] = 'Cash Incentive must be a number';
			}

			if (Object.keys(remarks).length === 0) {
				remarks = { valid: true };
			}

			return {
				'Data No.': leaseIdToDataNo[leaseId],
				...item,
				Remarks: remarks,
			};
		});

		return processedData;
	}, []);

	// Function to validate data
	const validateData = useCallback(
		(data) => {
			// Check if the data array is empty
			if (!data || data.length === 0) {
				toast.error('Excel file is empty or contains no valid data. Please upload a file with data.', toastConfig);
				setShow(false);
				setExcelTable([]);
				setValidationFailed(true);
				setData((prev) => ({ ...prev, emptyFileError: true }));
				return;
			}
			// Check if the data has only header row and no actual data
			if (data.length === 1 && Object.values(data[0]).every((value) => value === '')) {
				toast.error('Excel file contains headers but no data rows. Please add lease data to your file.', toastConfig);
				setShow(false);
				setExcelTable([]);
				setValidationFailed(true);
				setData((prev) => ({ ...prev, emptyFileError: true }));
				return;
			}
			const defaultKeys = Object.keys(INITIAL_EXPORT_DATA[0]);

			// Check if the data has the required columns
			if (data.length > 0) {
				const firstRow = data[0];
				const missingColumns = defaultKeys.filter((key) => !(key in firstRow));

				if (missingColumns.length > 0) {
					toast.error(
						`Excel file is missing required columns: ${missingColumns.join(', ')}. Please use the template provided.`,
						toastConfig,
					);
					setShow(false);
					setExcelTable([]);
					setValidationFailed(true);
					return;
				}
			}

			// Reset validation failed state since validation passed
			setValidationFailed(false);

			const normalizedData = data.map((obj) => {
				const newObj = { ...obj };
				defaultKeys.forEach((key) => {
					if (!newObj.hasOwnProperty(key)) {
						newObj[key] = '';
					}
				});
				return newObj;
			});

			// First pass: Do basic validation with getModifiedData
			let tableData = getModifiedData(normalizedData);

			// We'll create a new array with the validated data
			const finalTableData = [];

			// Group by Reference ID for advanced validations
			const groupedByReferenceId = _.groupBy(tableData, 'Reference Id');

			// Array to collect all effective date groups for cross-group validations
			const allEffectiveDateGroups = [];

			// Process each Reference ID group
			for (const referenceId in groupedByReferenceId) {
				const refItems = groupedByReferenceId[referenceId];

				// Group by effective date
				const groupedByEffectiveDate = _.groupBy(refItems, (item) => parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']));

				// Store all effective date groups for later cross-group validation
				for (const effectiveDate in groupedByEffectiveDate) {
					allEffectiveDateGroups.push(groupedByEffectiveDate[effectiveDate]);
				}

				// For each effective date group
				for (const effectiveDate in groupedByEffectiveDate) {
					const effectiveDateItems = groupedByEffectiveDate[effectiveDate];

					// 1. Check for "From Month <= To Month" in each row
					effectiveDateItems.forEach((item) => {
						// Start with original errors
						const processedRemarks = {};
						let isValid = true;

						// Check Payment Modality (add this)
						if (item['Payment Modality'] === '' || item['Payment Modality'] === undefined) {
							processedRemarks['Payment Modality Error'] = 'Payment Modality is required';
							isValid = false;
						} else if (
							item['Payment Modality']?.toLowerCase() !== 'advance basis' &&
							item['Payment Modality']?.toLowerCase() !== 'accrual basis'
						) {
							processedRemarks['Payment Modality Error'] = 'Payment Modality must be either Advance Basis or Accrual Basis';
							isValid = false;
						}

						// Check and preserve Payment Frequency errors from the original validation
						if (item.Remarks && item.Remarks['Payment Frequency']) {
							processedRemarks['Payment Frequency'] = item.Remarks['Payment Frequency'];
							isValid = false;
						}

						// Now add other validations
						// Only validate rows with non-dash values
						if (item['Rent (From Month)'] !== '-' && item['Rent (To Month)'] !== '-') {
							const fromMonth = Number(item['Rent (From Month)']);
							const toMonth = Number(item['Rent (To Month)']);

							if (fromMonth > toMonth) {
								processedRemarks['RentFromToError'] =
									`Rent (From Month) ${fromMonth} must be less than or equal to Rent (To Month) ${toMonth}`;
								isValid = false;
							}
						}

						// Similarly for Advance
						if (item['Advance (From Month)'] !== '-' && item['Advance (To Month)'] !== '-') {
							const fromMonth = Number(item['Advance (From Month)']);
							const toMonth = Number(item['Advance (To Month)']);

							if (fromMonth > toMonth) {
								processedRemarks['AdvanceFromToError'] =
									`Advance (From Month) ${fromMonth} must be less than or equal to Advance (To Month) ${toMonth}`;
								isValid = false;
							}
						}

						// Explicitly check Payment Frequency again to make sure
						if (item['Payment Frequency'] === '' || item['Payment Frequency'] === undefined) {
							processedRemarks['Payment Frequency'] = 'Payment Frequency is required';
							isValid = false;
						} else if (item['Payment Frequency'] !== 'Monthly' && item['Payment Frequency'] !== 'Quarterly') {
							processedRemarks['Payment Frequency'] = 'Payment Frequency must be either Monthly or Quarterly';
							isValid = false;
						}

						// Check new fields
						if (
							item['Upfront Lease Payment'] !== '' &&
							item['Upfront Lease Payment'] !== undefined &&
							isNaN(Number(item['Upfront Lease Payment']))
						) {
							processedRemarks['Upfront Lease Payment'] = 'Upfront Lease Payment must be a number';
							isValid = false;
						}

						if (
							item['Initial Direct Cost'] !== '' &&
							item['Initial Direct Cost'] !== undefined &&
							isNaN(Number(item['Initial Direct Cost']))
						) {
							processedRemarks['Initial Direct Cost'] = 'Initial Direct Cost must be a number';
							isValid = false;
						}

						if (item['Security Deposit'] !== '' && item['Security Deposit'] !== undefined && isNaN(Number(item['Security Deposit']))) {
							processedRemarks['Security Deposit'] = 'Security Deposit must be a number';
							isValid = false;
						}

						if (item['Cash Incentive'] !== '' && item['Cash Incentive'] !== undefined && isNaN(Number(item['Cash Incentive']))) {
							processedRemarks['Cash Incentive'] = 'Cash Incentive must be a number';
							isValid = false;
						}

						// Set the valid flag
						processedRemarks.valid = isValid;

						// Create the processed item with the complete remarks object
						const processedItem = {
							...item,
							Remarks: processedRemarks,
						};

						// Add the processed item to our final data
						finalTableData.push(processedItem);
					});

					// 2. Now check for sequence breaks
					// For Rent sequence
					const rentItems = [...effectiveDateItems]
						.filter((item) => item['Rent (From Month)'] !== '-' && item['Rent (To Month)'] !== '-')
						.sort((a, b) => Number(a['Rent (From Month)']) - Number(b['Rent (From Month)']));

					for (let i = 0; i < rentItems.length - 1; i++) {
						const current = rentItems[i];
						const next = rentItems[i + 1];

						const currentToMonth = Number(current['Rent (To Month)']);
						const nextFromMonth = Number(next['Rent (From Month)']);

						if (currentToMonth + 1 !== nextFromMonth) {
							// Find the corresponding item in our finalTableData that matches the NEXT row (where the error is)
							const itemIndex = finalTableData.findIndex(
								(item) =>
									item['Reference Id'] === next['Reference Id'] &&
									item['Lease Effective Date (YYYY-MM-DD)'] === next['Lease Effective Date (YYYY-MM-DD)'] &&
									item['Rent (From Month)'] === next['Rent (From Month)'] &&
									item['Rent (To Month)'] === next['Rent (To Month)'],
							);

							if (itemIndex !== -1) {
								// Create the error message without row number (we'll add it in the UI)
								const errorMsg = `Rent sequence break: expected ${currentToMonth + 1} but got ${nextFromMonth}`;

								if (finalTableData[itemIndex].Remarks.valid) {
									finalTableData[itemIndex].Remarks = {
										'Rent Sequence Error': errorMsg,
										valid: false,
									};
								} else {
									finalTableData[itemIndex].Remarks['Rent Sequence Error'] = errorMsg;
									finalTableData[itemIndex].Remarks.valid = false;
								}
							}
						}
					}

					// For Advance sequence
					const advanceItems = [...effectiveDateItems]
						.filter((item) => item['Advance (From Month)'] !== '-' && item['Advance (To Month)'] !== '-')
						.sort((a, b) => Number(a['Advance (From Month)']) - Number(b['Advance (From Month)']));

					for (let i = 0; i < advanceItems.length - 1; i++) {
						const current = advanceItems[i];
						const next = advanceItems[i + 1];

						const currentToMonth = Number(current['Advance (To Month)']);
						const nextFromMonth = Number(next['Advance (From Month)']);

						if (currentToMonth + 1 !== nextFromMonth) {
							// Find the corresponding item in our finalTableData that matches the NEXT row (where the error is)
							const itemIndex = finalTableData.findIndex(
								(item) =>
									item['Reference Id'] === next['Reference Id'] &&
									item['Lease Effective Date (YYYY-MM-DD)'] === next['Lease Effective Date (YYYY-MM-DD)'] &&
									item['Advance (From Month)'] === next['Advance (From Month)'] &&
									item['Advance (To Month)'] === next['Advance (To Month)'],
							);

							if (itemIndex !== -1) {
								// Create the error message without row number (we'll add it in the UI)
								const errorMsg = `Advance sequence break: expected ${currentToMonth + 1} but got ${nextFromMonth}`;

								if (finalTableData[itemIndex].Remarks.valid) {
									finalTableData[itemIndex].Remarks = {
										'Advance Sequence Error': errorMsg,
										valid: false,
									};
								} else {
									finalTableData[itemIndex].Remarks['Advance Sequence Error'] = errorMsg;
									finalTableData[itemIndex].Remarks.valid = false;
								}
							}
						}
					}

					// Add a specific check for lessor name consistency across the effective date group
					const uniqueLessorNames = [...new Set(effectiveDateItems.map((item) => item['Lessor Name']))];
					if (uniqueLessorNames.length > 1) {
						// There's an inconsistency in lessor names
						const referenceLessorName = effectiveDateItems[0]['Lessor Name'];

						// Find rows with inconsistent lessor names
						effectiveDateItems.forEach((item) => {
							if (item['Lessor Name'] !== referenceLessorName) {
								// Find the exact matching row in finalTableData using multiple fields for precision
								const itemIndex = finalTableData.findIndex(
									(tableItem) =>
										tableItem['Reference Id'] === item['Reference Id'] &&
										parseAndFormatExcelDate(tableItem['Lease Effective Date (YYYY-MM-DD)']) ===
										parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']) &&
										tableItem['Lessor Name'] === item['Lessor Name'] && // Match the specific lessor name
										tableItem['Rent (From Month)'] === item['Rent (From Month)'] &&
										tableItem['Rent (To Month)'] === item['Rent (To Month)'],
								);

								if (itemIndex !== -1) {
									const errorMsg = `Lessor Name must be consistent within the same effective date group. Expected: ${referenceLessorName}`;

									if (finalTableData[itemIndex].Remarks.valid) {
										finalTableData[itemIndex].Remarks = {
											'Lessor Name Error': errorMsg,
											valid: false,
										};
									} else {
										finalTableData[itemIndex].Remarks['Lessor Name Error'] = errorMsg;
										finalTableData[itemIndex].Remarks.valid = false;
									}
								}
							}
						});
					}

					// Consistency validation
					const consistencyErrors = validateConsistentFields(effectiveDateItems);

					// Update the error application logic for consistency errors
					consistencyErrors.forEach((error) => {
						// We need to be more precise about which row should get the error
						// Find the exact row where the inconsistency was detected
						const itemIndex = finalTableData.findIndex(
							(item) =>
								item['Data No.'] === error.rowIndex &&
								item['Reference Id'] === error.referenceId &&
								parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']) === error.effectiveDate &&
								item['Rent (From Month)'] === error.fromMonth &&
								item['Rent (To Month)'] === error.toMonth,
						);

						if (itemIndex !== -1) {
							// Add the error to this specific row
							if (finalTableData[itemIndex].Remarks.valid) {
								finalTableData[itemIndex].Remarks = {
									'Consistency Error': error.message,
									valid: false,
								};
							} else {
								finalTableData[itemIndex].Remarks['Consistency Error'] = error.message;
								finalTableData[itemIndex].Remarks.valid = false;
							}
						}
					});

					// NEW VALIDATION 1: Max Rent (To Month) <= Max Advance (To Month)
					const rentAdvanceMonthErrors = validateRentAdvanceMonths(effectiveDateItems);
					rentAdvanceMonthErrors.forEach((error) => {
						const itemIndex = finalTableData.findIndex(
							(item) =>
								item['Data No.'] === error.rowIndex &&
								item['Reference Id'] === error.originalRow['Reference Id'] &&
								parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']) ===
								parseAndFormatExcelDate(error.originalRow['Lease Effective Date (YYYY-MM-DD)']),
						);

						if (itemIndex !== -1) {
							const errorMsg = error.message;

							if (finalTableData[itemIndex].Remarks.valid) {
								finalTableData[itemIndex].Remarks = {
									'Rent Advance Month Error': errorMsg,
									valid: false,
								};
							} else {
								finalTableData[itemIndex].Remarks['Rent Advance Month Error'] = errorMsg;
								finalTableData[itemIndex].Remarks.valid = false;
							}
						}
					});

					// NEW VALIDATION 4: Total Rent Amount >= Total Advance Adjustment Amount
					const rentVsAdvanceErrors = validateRentVsAdvance(effectiveDateItems);
					rentVsAdvanceErrors.forEach((error) => {
						const itemIndex = finalTableData.findIndex(
							(item) =>
								item['Data No.'] === error.rowIndex &&
								item['Reference Id'] === error.originalRow['Reference Id'] &&
								parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']) ===
								parseAndFormatExcelDate(error.originalRow['Lease Effective Date (YYYY-MM-DD)']),
						);

						if (itemIndex !== -1) {
							const errorMsg = error.message;

							if (finalTableData[itemIndex].Remarks.valid) {
								finalTableData[itemIndex].Remarks = {
									'Rent vs Advance Error': errorMsg,
									valid: false,
								};
							} else {
								finalTableData[itemIndex].Remarks['Rent vs Advance Error'] = errorMsg;
								finalTableData[itemIndex].Remarks.valid = false;
							}
						}
					});
				}
			}

			// NEW VALIDATION 2: Effective Date within lease range
			allEffectiveDateGroups.forEach((group) => {
				const effectiveDateRangeErrors = validateEffectiveDateRange(group, tableData);
				effectiveDateRangeErrors.forEach((error) => {
					const itemIndex = finalTableData.findIndex(
						(item) =>
							item['Data No.'] === error.rowIndex &&
							item['Reference Id'] === error.originalRow['Reference Id'] &&
							parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']) ===
							parseAndFormatExcelDate(error.originalRow['Lease Effective Date (YYYY-MM-DD)']),
					);

					if (itemIndex !== -1) {
						const errorMsg = error.message;

						if (finalTableData[itemIndex].Remarks.valid) {
							finalTableData[itemIndex].Remarks = {
								'Effective Date Range Error': errorMsg,
								valid: false,
							};
						} else {
							finalTableData[itemIndex].Remarks['Effective Date Range Error'] = errorMsg;
							finalTableData[itemIndex].Remarks.valid = false;
						}
					}
				});
			});

			// NEW VALIDATION 3: Effective Date order
			const effectiveDateOrderErrors = validateEffectiveDateOrder(allEffectiveDateGroups);
			effectiveDateOrderErrors.forEach((error) => {
				const itemIndex = finalTableData.findIndex(
					(item) =>
						item['Data No.'] === error.rowIndex &&
						item['Reference Id'] === error.originalRow['Reference Id'] &&
						parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']) ===
						parseAndFormatExcelDate(error.originalRow['Lease Effective Date (YYYY-MM-DD)']),
				);

				if (itemIndex !== -1) {
					const errorMsg = error.message;

					if (finalTableData[itemIndex].Remarks.valid) {
						finalTableData[itemIndex].Remarks = {
							'Effective Date Order Error': errorMsg,
							valid: false,
						};
					} else {
						finalTableData[itemIndex].Remarks['Effective Date Order Error'] = errorMsg;
						finalTableData[itemIndex].Remarks.valid = false;
					}
				}
			});

			// Sort the final data
			finalTableData.sort((a, b) => a['Data No.'] - b['Data No.']);

			// After all validation is done, add grouping information to the final data
			// for better visual display
			const groupedFinalData = [];
			let currentGroupId = 0;

			// First group by Reference ID
			const groupedByRefId = _.groupBy(finalTableData, 'Reference Id');

			for (const refId in groupedByRefId) {
				const refItems = groupedByRefId[refId];

				// Then by effective date
				const groupedByEffDate = _.groupBy(refItems, (item) => parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']));

				// Assign a group ID to each effective date group
				for (const effDate in groupedByEffDate) {
					currentGroupId++;
					const effDateItems = groupedByEffDate[effDate];

					// Add the group ID to each item
					effDateItems.forEach((item) => {
						groupedFinalData.push({
							...item,
							groupId: currentGroupId,
						});
					});
				}
			}

			// Sort the grouped data
			groupedFinalData.sort((a, b) => a['Data No.'] - b['Data No.']);

			// Update Excel Data and Table
			setData((prev) => ({ ...prev, excelData: normalizedData }));
			setExcelTable(groupedFinalData);
		},
		[getModifiedData, setExcelTable],
	);

	// Function to handle submit button click
	const handleExcelSubmit = useCallback(() => {
		// Show confirmation modal
		setData((prev) => ({
			...prev,
			modalInfo: {
				head: 'Lease Bulk Upload',
				action: 'submit',
				activationStatus: 'process lease records',
			},
		}));
		setUiState((prev) => ({ ...prev, showModal: true, show: false }));
	}, []);

	// Function to prepare and submit data
	// const handleSubmitExcelData = useCallback(async () => {
	// 	// Group all data by Reference ID first
	// 	const groupedByReferenceId = _.groupBy(data.excelTable, 'Reference Id');
	// 	const createPayloadArray = [];
	// 	const updatePayloadArray = [];
	//
	// 	// Process each Reference ID group
	// 	for (const referenceId in groupedByReferenceId) {
	// 		const refItems = groupedByReferenceId[referenceId];
	//
	// 		// Sort by effective date
	// 		const sortedItems = [...refItems].sort((a, b) => {
	// 			const aDate = parseAndFormatExcelDate(a['Lease Effective Date (YYYY-MM-DD)']);
	// 			const bDate = parseAndFormatExcelDate(b['Lease Effective Date (YYYY-MM-DD)']);
	// 			return dayjs(aDate).diff(dayjs(bDate));
	// 		});
	// 		// Group by effective date
	// 		const groupedByEffectiveDate = _.groupBy(sortedItems, (item) => parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']));
	// 		console.log('groupedByEffectiveDate', groupedByEffectiveDate);
	// 		// Get all effective dates in chronological order
	// 		const effectiveDates = Object.keys(groupedByEffectiveDate).sort((a, b) => dayjs(a).diff(dayjs(b)));
	// 		const modifiedGrossRentListSet = transformToGrossRentListSet(groupedByEffectiveDate);
	// 		if (effectiveDates.length === 0) {
	// 			console.error('No effective dates found for reference ID:', referenceId);
	// 			continue;
	// 		}
	//
	// 		// Process the initial lease data (first effective date)
	// 		const initialEffectiveDate = effectiveDates[0];
	// 		const initialItems = groupedByEffectiveDate[initialEffectiveDate];
	// 		// Get the start date from the first item
	// 		const startDate = parseAndFormatExcelDate(initialItems[0]['Lease Start Date (YYYY-MM-DD)']);
	//
	// 		// Process lease data for the initial effective date
	// 		const {
	// 			inputChangeAdvanceAmounts,
	// 			advanceAmountList,
	// 			totalAdvanceAmount,
	// 			maxAdvanceToMonth,
	// 			inputChangeGrossRents,
	// 			grossRentList,
	// 			totalRentAmount,
	// 			maxLeaseTerm,
	// 		} = processLeaseData(initialItems);
	//
	// 		// Calculate end date based on max lease term
	// 		const endDate = dayjs(startDate).add(+maxLeaseTerm, 'month').subtract(1, 'day').format('YYYY-MM-DD');
	//
	// 		const formattedStartDate = formatDate(startDate);
	// 		const formattedEndDate = formatDate(endDate);
	// 		const { day: startDay, month: startMonth, year: startYear } = getDateParts(dayjs(startDate).format('YYYY-MM-DD'));
	//
	// 		// Initialize changes array with the first effective date's data
	// 		const changes = [prepareChangeObject(initialItems, startDate, 'Initial Rent')];
	//
	// 		// Add changes for each subsequent effective date (modifications)
	// 		for (let i = 1; i < effectiveDates.length; i++) {
	// 			const effectiveDate = effectiveDates[i];
	// 			const items = groupedByEffectiveDate[effectiveDate];
	//
	// 			// Determine change description based on what changed
	// 			let description = 'Modification';
	//
	// 			// Get previous effective date's data for comparison
	// 			const prevEffectiveDate = effectiveDates[i - 1];
	// 			const prevEffectiveDateItems = groupedByEffectiveDate[prevEffectiveDate];
	// 			const prevProcessedData = processLeaseData(prevEffectiveDateItems);
	// 			const currentProcessedData = processLeaseData(items);
	//
	// 			// Compare rent and advance data to determine what changed
	// 			const rentChanged = !_.isEqual(prevProcessedData.inputChangeGrossRents, currentProcessedData.inputChangeGrossRents);
	//
	// 			const advanceChanged = !_.isEqual(prevProcessedData.inputChangeAdvanceAmounts, currentProcessedData.inputChangeAdvanceAmounts);
	//
	// 			// Set appropriate description
	// 			if (rentChanged && advanceChanged) {
	// 				description = 'Change In rent';
	// 			} else if (rentChanged) {
	// 				description = 'Change In rent';
	// 			} else if (advanceChanged) {
	// 				description = 'Change In rent';
	// 			}
	//
	// 			// Add the change
	// 			changes.push(prepareChangeObject(items, startDate, description));
	// 		}
	//
	// 		// Prepare the main payload object for this reference ID
	// 		const leasePayload = {
	// 			leaseTitle: initialItems[0]['Lease Title'],
	// 			leaseType: initialItems[0]['Lease Type'],
	// 			lessorName: initialItems[0]['Lessor Name'],
	// 			paymentFrequency: String(initialItems[0]['Payment Frequency']),
	// 			leaseStartDate: `${formattedStartDate}T00:00:00.000Z`,
	// 			leaseEndDate: formattedEndDate,
	// 			leaseTerm: initialItems[0]['Payment Frequency']?.toLowerCase() === 'quarterly' ? Number(maxLeaseTerm) / 3 : Number(maxLeaseTerm),
	// 			grossRent: 0,
	// 			initialDiscountRate: String(initialItems[0]['Incremental Borrowing Rate']),
	// 			escalationPercentage: String(initialItems[0]['Escalation (%)']),
	// 			paymentModality: String(
	// 				initialItems[0]['Payment Modality']?.toLowerCase() === 'advance basis'
	// 					? 'Start'
	// 					: initialItems[0]['Payment Modality']?.toLowerCase() === 'accrual basis'
	// 						? 'End'
	// 						: ''
	// 			),
	// 			advanceDuration: String(maxAdvanceToMonth),
	// 			advanceAmount: String(totalAdvanceAmount),
	// 			changes,
	// 			lastModifiedDate: dayjs(),
	// 			endOfFinancialYear: dayjs().month(11).date(31),
	// 			startDay,
	// 			startMonth,
	// 			startYear,
	// 			advanceAmountList,
	// 			grossRentList,
	// 			advanceAmountListSet: [advanceAmountList],
	// 			grossRentListSet: modifiedGrossRentListSet,
	// 			grossRents: inputChangeGrossRents,
	// 			advanceAmounts: inputChangeAdvanceAmounts,
	// 			modificationSequence: changes.length - 1, // 0 for new, increments for each modification
	// 			effectiveDateHistory: effectiveDates.map((date) => `${date}T00:00:00.000Z`),
	// 			referenceId: referenceId, // Add reference ID to help identify the lease
	// 			upfrontLeasePayment: Number(initialItems[0]['Upfront Lease Payment'] || 0),
	// 			initialDirectCost: Number(initialItems[0]['Initial Direct Cost'] || 0),
	// 			securityDeposit: Number(initialItems[0]['Security Deposit'] || 0),
	// 			cashIncentiveAmount: Number(initialItems[0]['Cash Incentive'] || 0),
	// 			deletionMarker: true,
	// 		};
	//
	// 		// Determine whether this is a creation or modification based on the number of effective dates
	// 		if (effectiveDates.length === 1) {
	// 			// Single effective date = creation
	// 			createPayloadArray.push(leasePayload);
	// 		} else {
	// 			// Multiple effective dates = modification
	// 			updatePayloadArray.push(leasePayload);
	// 		}
	// 	}
	//
	// 	// Create the API payloads
	// 	let payload;
	//
	// 	// if (createPayloadArray.length > 0 && updatePayloadArray.length === 0) {
	// 	// 	// Only creations
	// 	// 	payload = {
	// 	// 		operation: 'add-bulk',
	// 	// 		processCode: state?.processCode,
	// 	// 		suffixCode: '',
	// 	// 		data: createPayloadArray,
	// 	// 	};
	// 	// } else if (createPayloadArray.length === 0 && updatePayloadArray.length > 0) {
	// 	// 	// Only modifications
	// 	// 	payload = {
	// 	// 		operation: 'add-bulk',
	// 	// 		processCode: state?.processCode,
	// 	// 		suffixCode: '',
	// 	// 		data: updatePayloadArray,
	// 	// 	};
	// 	// }
	// 	//  else {
	// 	// Mixed - need to handle both (process creations first)
	// 	toast.info('Processing both new leases and modifications...', toastConfig);
	//
	// 	// First process creations
	//
	// 	const createPayload = {
	// 		operation: 'add-bulk',
	// 		processCode: state?.processCode,
	// 		suffixCode: '',
	// 		data: [...createPayloadArray, ...updatePayloadArray],
	// 	};
	//
	// 	await uploadBulkIdentityCase(createPayload).unwrap();
	//
	// 	// Then process modifications
	// 	// payload = {
	// 	// 	operation: 'add-bulk',
	// 	// 	processCode: state?.processCode,
	// 	// 	suffixCode: '',
	// 	// 	data: updatePayloadArray,
	// 	// };
	// 	// }
	//
	// 	// Submit the payload
	// 	// if (payload) {
	// 	// 	uploadBulkIdentityCase(payload);
	// 	// }
	// }, [data.excelTable, state?.processCode, uploadBulkIdentityCase]);
	const handleSubmitExcelData = useCallback(async () => {
		// Group all data by Reference ID first
		const groupedByReferenceId = _.groupBy(data.excelTable, 'Reference Id');
		const createPayloadArray = [];
		const updatePayloadArray = [];

		// Process each Reference ID group
		for (const referenceId in groupedByReferenceId) {
			const refItems = groupedByReferenceId[referenceId];

			// Sort by effective date
			const sortedItems = [...refItems].sort((a, b) => {
				const aDate = parseAndFormatExcelDate(a['Lease Effective Date (YYYY-MM-DD)']);
				const bDate = parseAndFormatExcelDate(b['Lease Effective Date (YYYY-MM-DD)']);
				return dayjs(aDate).diff(dayjs(bDate));
			});

			// Group by effective date
			const groupedByEffectiveDate = _.groupBy(sortedItems, (item) => parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']));

			// Get all effective dates in chronological order
			const effectiveDates = Object.keys(groupedByEffectiveDate).sort((a, b) => dayjs(a).diff(dayjs(b)));

			if (effectiveDates.length === 0) {
				console.error('No effective dates found for reference ID:', referenceId);
				continue;
			}

			// Get FIRST effective date for initial lease data (fixed)
			const initialEffectiveDate = effectiveDates[0]; // First, not last!
			const initialItems = groupedByEffectiveDate[initialEffectiveDate];

			// Get LAST effective date for parent-level data (latest state)
			const lastEffectiveDate = effectiveDates[effectiveDates.length - 1];
			const lastItems = groupedByEffectiveDate[lastEffectiveDate];

			// Get the start date from the first item
			const startDate = parseAndFormatExcelDate(initialItems[0]['Lease Start Date (YYYY-MM-DD)']);

			// Calculate the MAXIMUM lease term from ALL effective dates combined
			let maxLeaseTerm = 0;
			effectiveDates.forEach((effectiveDate) => {
				const items = groupedByEffectiveDate[effectiveDate];
				const { maxLeaseTerm: currentMaxTerm } = processLeaseData(items);
				maxLeaseTerm = Math.max(maxLeaseTerm, currentMaxTerm);
			});

			// Calculate end date based on MAXIMUM lease term
			const endDate = dayjs(startDate).add(maxLeaseTerm, 'month').subtract(1, 'day').format('YYYY-MM-DD');
			const {
				day: startDay,
				month: startMonth,
				year: startYear,
			} = getDateParts(dayjs(startDate).format('YYYY-MM-DD'));

			// Build the final arrays for the parent level (cumulative from all effective dates)
			const finalAdvanceAmounts = new Array(maxLeaseTerm).fill(0);
			const finalGrossRents = new Array(maxLeaseTerm).fill(0);
			let finalGrossRentList = [];
			let finalAdvanceAmountList = [];

			// Process each effective date to build cumulative data
			effectiveDates.forEach((effectiveDate) => {
				const items = groupedByEffectiveDate[effectiveDate];

				// Update cumulative arrays with data from this effective date
				items.forEach((item) => {
					if (item['Rent (From Month)'] !== '-' && item['Rent (To Month)'] !== '-' && item['Rent Amount'] !== '-') {
						const fromMonth = Number(item['Rent (From Month)']);
						const toMonth = Number(item['Rent (To Month)']);
						const amount = Number(item['Rent Amount']);

						for (let month = fromMonth; month <= toMonth; month++) {
							if (month - 1 < maxLeaseTerm) {
								finalGrossRents[month - 1] = amount;
							}
						}
					}

					if (item['Advance (From Month)'] !== '-' && item['Advance (To Month)'] !== '-' && item['Advance Adjustment Amount'] !== '-') {
						const fromMonth = Number(item['Advance (From Month)']);
						const toMonth = Number(item['Advance (To Month)']);
						const amount = Number(item['Advance Adjustment Amount']);

						for (let month = fromMonth; month <= toMonth; month++) {
							if (month - 1 < maxLeaseTerm) {
								finalAdvanceAmounts[month - 1] = amount;
							}
						}
					}
				});
			});

			// Build final gross rent list (combining all periods)
			let currentGrossFrom = 1;
			let lastGrossAmount = 0;
			finalGrossRents.forEach((amount, index) => {
				if (amount !== lastGrossAmount && amount > 0) {
					if (lastGrossAmount > 0) {
						// Close previous period
						finalGrossRentList.push({
							from: currentGrossFrom,
							to: String(index),
							amount: lastGrossAmount.toLocaleString('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							}),
							remarks: '',
						});
						currentGrossFrom = index + 1;
					}
					lastGrossAmount = amount;
				}
			});
			// Close the last period
			if (lastGrossAmount > 0) {
				finalGrossRentList.push({
					from: currentGrossFrom,
					to: String(maxLeaseTerm),
					amount: lastGrossAmount.toLocaleString('en-US', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}),
					remarks: '',
				});
			}

			// Build final advance amount list
			let currentAdvanceFrom = 1;
			let lastAdvanceAmount = 0;
			finalAdvanceAmounts.forEach((amount, index) => {
				if (amount !== lastAdvanceAmount && amount > 0) {
					if (lastAdvanceAmount > 0) {
						// Close previous period
						finalAdvanceAmountList.push({
							from: currentAdvanceFrom,
							to: String(index),
							amount: lastAdvanceAmount.toLocaleString('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							}),
						});
						currentAdvanceFrom = index + 1;
					}
					lastAdvanceAmount = amount;
				}
			});
			// Close the last advance period
			if (lastAdvanceAmount > 0) {
				finalAdvanceAmountList.push({
					from: currentAdvanceFrom,
					to: String(finalAdvanceAmounts.filter((a) => a > 0).length),
					amount: lastAdvanceAmount.toLocaleString('en-US', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}),
				});
			}

			// Build grossRentListSet (cumulative for each effective date)
			let grossRentListSet = [];
			let cumulativeGrossRentList = [];

			effectiveDates.forEach((effectiveDate, index) => {
				const items = groupedByEffectiveDate[effectiveDate];
				const { grossRentList } = processLeaseData(items);

				// Add new gross rent entries to cumulative list
				grossRentList.forEach((newEntry) => {
					cumulativeGrossRentList.push(newEntry);
				});

				// Add the cumulative list to the set
				grossRentListSet.push([...cumulativeGrossRentList]);
			});

			// Build advanceAmountListSet (should remain the same for modifications)
			const { advanceAmountList: initialAdvanceList } = processLeaseData(initialItems);
			let advanceAmountListSet = [initialAdvanceList];

			// For modifications, advance typically doesn't change, so add empty array
			for (let i = 1; i < effectiveDates.length; i++) {
				advanceAmountListSet.push([]);
			}

			// Initialize changes array sequentially with cumulative data
			const changes = [];
			let cumulativeGrossRents = new Array(maxLeaseTerm).fill(0);
			let cumulativeAdvanceAmounts = new Array(maxLeaseTerm).fill(0);

			effectiveDates.forEach((effectiveDate, index) => {
				const items = groupedByEffectiveDate[effectiveDate];
				const description = index === 0 ? 'Initial Rent' : index === 1 ? 'Change In rent' : 'Change In rent and advance amount';

				if (index === 0) {
					// For initial change, use the data as is
					changes.push(prepareChangeObject(items, startDate, description, maxLeaseTerm));

					// Build initial cumulative arrays
					const { inputChangeGrossRents, inputChangeAdvanceAmounts } = processLeaseData(items);
					inputChangeGrossRents.forEach((value, idx) => {
						if (value > 0 && idx < maxLeaseTerm) {
							cumulativeGrossRents[idx] = value;
						}
					});
					inputChangeAdvanceAmounts.forEach((value, idx) => {
						if (value > 0 && idx < maxLeaseTerm) {
							cumulativeAdvanceAmounts[idx] = value;
						}
					});
				} else {
					// For modifications, update cumulative arrays with new data
					items.forEach((item) => {
						if (item['Rent (From Month)'] !== '-' && item['Rent (To Month)'] !== '-' && item['Rent Amount'] !== '-') {
							const fromMonth = Number(item['Rent (From Month)']);
							const toMonth = Number(item['Rent (To Month)']);
							const amount = Number(item['Rent Amount']);

							for (let month = fromMonth; month <= toMonth; month++) {
								if (month - 1 < maxLeaseTerm) {
									cumulativeGrossRents[month - 1] = amount;
								}
							}
						}

						if (item['Advance (From Month)'] !== '-' && item['Advance (To Month)'] !== '-' && item['Advance Adjustment Amount'] !== '-') {
							const fromMonth = Number(item['Advance (From Month)']);
							const toMonth = Number(item['Advance (To Month)']);
							const amount = Number(item['Advance Adjustment Amount']);

							for (let month = fromMonth; month <= toMonth; month++) {
								if (month - 1 < maxLeaseTerm) {
									cumulativeAdvanceAmounts[month - 1] = amount;
								}
							}
						}
					});

					// Create change object and override arrays with cumulative data
					const changeObj = prepareChangeObject(items, startDate, description, maxLeaseTerm);
					// Override arrays with cumulative data`
					const [finalRents, finalAdvances] = resizeArraysConcise([...cumulativeGrossRents], [...cumulativeAdvanceAmounts], Number(changeObj?.inputChangeLeaseTerm));
					changeObj.inputChangeGrossRents =finalRents;
					changeObj.inputChangeAdvanceAmounts = finalAdvances;
					changeObj.inputChangeAdvance = cumulativeAdvanceAmounts?.reduce((sum, amount) => sum + amount, 0);
					// console.log(changeObj,"changeObj123");

					changes.push(changeObj);
				}
			});

			// Calculate final totals and durations
			const finalTotalAdvanceAmount = finalAdvanceAmounts.reduce((sum, amount) => sum + amount, 0);
			const finalAdvanceDuration = finalAdvanceAmounts.findLastIndex((amount) => amount > 0) + 1; // Last month with advance payment

			// Build effectiveDateHistory
			const effectiveDateHistory = effectiveDates.map((date) => utcConverter(dayjs(date)));

			// Prepare the main payload object for this reference ID
			const leasePayload = {
				// Basic Information (from initial data)
				leaseTitle: initialItems[0]['Lease Title'],
				leaseType: initialItems[0]['Lease Type'],
				lessorName: initialItems[0]['Lessor Name'],
				paymentFrequency: String(initialItems[0]['Payment Frequency']),

				// Dates - properly formatted with utcConverter
				leaseStartDate: utcConverter(dayjs(startDate)),
				leaseEndDate: utcConverter(dayjs(endDate)),
				modifiedDateTime: utcConverter(dayjs()),
				lastModifiedDate: utcConverter(dayjs()),

				// Financial Terms (use LATEST data for parent level)
				leaseTerm: Number(maxLeaseTerm),
				grossRent: 0, // Default 0 as expected
				escalationPercentage: String(lastItems[0]['Escalation (%)']),
				initialDiscountRate: String(lastItems[0]['Incremental Borrowing Rate']),

				// Payment Terms (use LATEST data)
				paymentModality: String(
					lastItems[0]['Payment Modality']?.toLowerCase() === 'advance basis'
						? 'Start'
						: lastItems[0]['Payment Modality']?.toLowerCase() === 'accrual basis'
							? 'End'
							: '',
				),
				paymentModalityLabel: lastItems[0]['Payment Modality'],

				// Advance Information (use final calculated values)
				advanceDuration: String(finalAdvanceDuration),
				advanceAmount: String(finalTotalAdvanceAmount),
				advanceAmounts: finalAdvanceAmounts,
				advanceAmountList: finalAdvanceAmountList,
				advanceAmountListSet,

				// Gross Rent Information (use final calculated values)
				grossRents: finalGrossRents,
				grossRentList: finalGrossRentList,
				grossRentListSet,

				// Additional Financial Fields (use LATEST data)
				upfrontLeasePayment: String(lastItems[0]['Upfront Lease Payment'] || 0),
				initialDirectCost: String(lastItems[0]['Initial Direct Cost'] || 0),
				securityDeposit: String(lastItems[0]['Security Deposit'] || 0),
				cashIncentiveAmount: String(lastItems[0]['Cash Incentive'] || 0),

				// Date Parts
				startDay,
				startMonth,
				startYear,
				endOfFinancialYear: utcConverter(dayjs().month(11).date(31)),

				// Changes and History
				changes,
				modificationSequence: effectiveDates.length - 1,
				effectiveDateHistory,
				deletionMarker: true, // Default to true for new leases

				// Metadata
				referenceId: referenceId,
			};

			// Determine whether this is a creation or modification based on the number of effective dates
			if (effectiveDates.length === 1) {
				// Single effective date = creation
				createPayloadArray.push(leasePayload);
			} else {
				// Multiple effective dates = modification
				updatePayloadArray.push(leasePayload);
			}
		}

		// Create the API payload
		toast.info('Processing lease records...', toastConfig);

		const bulkPayload = {
			operation: 'add-bulk',
			processCode: state?.processCode,
			suffixCode: '',
			data: [...createPayloadArray, ...updatePayloadArray],
		};

		try {
			await uploadBulkIdentityCase(bulkPayload).unwrap();
		} catch (error) {
			console.error('Bulk upload failed:', error);
			toast.error('Bulk upload failed. Please check the data and try again.', toastConfig);
		}
	}, [data.excelTable, state?.processCode, uploadBulkIdentityCase]);
	// UI rendering helper functions
	const getCellStyle = useCallback((columnKey, value, lrm) => {
		switch (columnKey) {
			case 'Lessor Name':
				// Check if there's a Lessor Name Error in the remarks
				return {
					border: lrm.Remarks && lrm.Remarks['Lessor Name Error'] ? '2px solid red' : '',
				};

			case 'Incremental Borrowing Rate':
				// Check both basic validation and consistency errors
				return {
					border:
						value === '' ||
						isNaN(Number(value)) ||
						(lrm.Remarks && lrm.Remarks['Consistency Error'] && lrm.Remarks['Consistency Error'].includes('Incremental Borrowing Rate'))
							? '2px solid red'
							: '',
				};

			case 'Payment Frequency':
				return {
					border: value === '' || !(value?.toLowerCase() === 'monthly' || value?.toLowerCase() === 'quarterly') ? '2px solid red' : '',
				};

			case 'Lease Start Date (YYYY-MM-DD)':
				return {
					border: value === '' ? '2px solid red' : '',
				};

			case 'Lease Effective Date (YYYY-MM-DD)':
				return {
					border: value === '' ? '2px solid red' : '',
				};

			case 'Rent (From Month)':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Rent (To Month)':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Rent Amount':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Advance (From Month)':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Advance (To Month)':
				// Special condition: check Advance (From Month) value
				return {
					border: lrm['Advance (From Month)'] !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Advance Adjustment Amount':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Escalation (%)':
				return {
					border: value === '' || isNaN(Number(value)) ? '2px solid red' : '',
				};

			case 'Payment Modality':
				return {
					border:
						value === '' || !(value?.toLowerCase() === 'advance basis' || value?.toLowerCase() === 'accrual basis')
							? '2px solid red'
							: '',
				};
			case 'Upfront Lease Payment':
				return {
					border: value !== '' && value !== undefined && isNaN(Number(value)) ? '2px solid red' : '',
				};
			case 'Initial Direct Cost':
				return {
					border: value !== '' && value !== undefined && isNaN(Number(value)) ? '2px solid red' : '',
				};
			case 'Security Deposit':
				return {
					border: value !== '' && value !== undefined && isNaN(Number(value)) ? '2px solid red' : '',
				};
			case 'Cash Incentive':
				return {
					border: value !== '' && value !== undefined && isNaN(Number(value)) ? '2px solid red' : '',
				};
			default:
				return {};
		}
	}, []);

	const getCellContent = useCallback(
		(columnKey, value, lrm) => {
			switch (columnKey) {
				case 'Reference Id':
					return value;

				case 'Lease Title':
					return value;

				case 'Lease Type':
					return value;

				case 'Lessor Name':
					return value;

				case 'Payment Frequency':
					if (value === '') return ' Required ';
					if (value?.toLowerCase() === 'monthly' || value?.toLowerCase() === 'quarterly') {
						return value;
					}
					return ' Enter monthly or quarterly as value ';

				case 'Lease Start Date (YYYY-MM-DD)':
					return value === '' ? ' Required ' : formatDate(parseAndFormatExcelDate(value));

				case 'Lease Effective Date (YYYY-MM-DD)':
					return value === '' ? ' Required ' : formatDate(parseAndFormatExcelDate(value));

				case 'Rent (From Month)':
					if (value === '') return ' Required ';
					if (value === '-') return '-';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return value;

				case 'Rent (To Month)':
					if (value === '') return ' Required ';
					if (lrm['Rent (From Month)'] === '-') return '-';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return value;

				case 'Rent Amount':
					if (value === '') return ' Required ';
					if (value === '-') return '-';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return formatNumber(value, 2);

				case 'Advance (From Month)':
					if (value === '') return ' Required ';
					if (value === '-') return '-';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return value;

				case 'Advance (To Month)':
					if (value === '') return ' Required ';
					if (lrm['Advance (From Month)'] === '-') return '-';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return value;

				case 'Advance Adjustment Amount':
					if (value === '') return ' Required ';
					if (value === '-') return '-';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return formatNumber(value);

				case 'Incremental Borrowing Rate':
					if (value === '') return ' Required ';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return value;

				case 'Escalation (%)':
					if (value === '') return ' Required ';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return value;

				case 'Payment Modality':
					if (value === '') return ' Required ';
					if (value?.toLowerCase() === 'advance basis' || value?.toLowerCase() === 'accrual basis') {
						return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
					}
					return ' Enter Advance Basis or Accrual Basis as value ';
				case 'Upfront Lease Payment':
					if (value === '' || value === undefined) return '0';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return formatNumber(value);
				case 'Initial Direct Cost':
					if (value === '' || value === undefined) return '0';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return formatNumber(value);
				case 'Security Deposit':
					if (value === '' || value === undefined) return '0';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return formatNumber(value);
				case 'Cash Incentive':
					if (value === '' || value === undefined) return '0';
					if (isNaN(Number(value))) return ' Insert a Numeric Value ';
					return formatNumber(value);
				case 'Action':
					// Special case for the action column
					return (
						<div>
							{lrm['Remarks'].valid ? (
								<CheckSquareOutlined
									size="large"
									style={{
										fontSize: '20px',
										color: theme.palette.lynTheme.success,
									}}
								/>
							) : (
								<Popover
									trigger="click"
									placement="left"
									title={
										<div style={{ fontWeight: 'bold', textAlign: 'center' }}>
											Validation Errors - Lease Reference ID: {lrm['Reference Id']}
										</div>
									}
									content={<ErrorModal
										modalData={transformErrors(lrm['Remarks'], lrm['Data No.'])} />}
									overlayStyle={{ maxWidth: '500px' }}
								>
									<Button
										style={{
											backgroundColor: theme.palette.error?.main || 'red',
											marginRight: '10px',
										}}
										type="primary"
									>
										Show Errors ({Object.keys(lrm['Remarks']).filter((k) => k !== 'valid').length})
									</Button>
								</Popover>
							)}
						</div>
					);

				default:
					return value;
			}
		},
		[theme.palette.lynTheme.success, theme.palette.error?.main],
	);

	// Function to calculate statistics from the excel data
	const calculateStatistics = useCallback(() => {
		if (!data.excelTable || data.excelTable.length === 0) {
			return {
				uniqueLeaseCount: 0,
				totalRowCount: 0,
				totalModifications: 0,
				leasesWithModifications: 0,
			};
		}

		// Group by Reference ID
		const groupedByReferenceId = _.groupBy(data.excelTable, 'Reference Id');

		// Calculate unique lease count (unique reference IDs)
		const uniqueLeaseCount = Object.keys(groupedByReferenceId).length;

		// Calculate total row count
		const totalRowCount = data.excelTable.length;

		// Calculate modifications and leases with modifications
		let totalModifications = 0;
		let leasesWithModifications = 0;

		Object.keys(groupedByReferenceId).forEach((referenceId) => {
			const refItems = groupedByReferenceId[referenceId];

			// Group by effective date for this reference ID
			const groupedByEffectiveDate = _.groupBy(refItems, (item) => parseAndFormatExcelDate(item['Lease Effective Date (YYYY-MM-DD)']));

			const effectiveDateGroupsCount = Object.keys(groupedByEffectiveDate).length;

			// If more than one effective date group, this lease has modifications
			if (effectiveDateGroupsCount > 1) {
				leasesWithModifications++;
				// Number of modifications = effective date groups - 1
				totalModifications += effectiveDateGroupsCount - 1;
			}
		});

		return {
			uniqueLeaseCount,
			totalRowCount,
			totalModifications,
			leasesWithModifications,
		};
	}, [data.excelTable]);

	// Render component
	return (
		<div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'flex-start',
					marginBottom: '20px',
					// paddingLeft: '20px',
					paddingRight: '20px',
				}}
			>
				{/* Demo download section */}
				{!uiState.show && !uiState.validationFailed && (
					<div>
						<p>
							To download a demo <img src={excel} alt="excel" width={22}
													style={{ margin: '0 5px' }} /> file{' '}
							<Button
								size="small"
								type="dashed"
								onClick={(e) => {
									e.stopPropagation();
									exportExcelFileWithGuidelines(INITIAL_EXPORT_DATA, 'LTM_BulkUpload.xlsx');
								}}
								style={{ color: '#1677ff', borderColor: '#1677ff' }}
							>
								Click Here
							</Button>
						</p>
					</div>
				)}

				{/* Statistics section */}
				{uiState.show && data.excelTable && data.excelTable.length > 0 && !uiState.validationFailed && (
					<div
						style={{
							backgroundColor: '#f8f9fa',
							border: '1px solid #dee2e6',
							borderRadius: '8px',
							padding: '16px',
							minWidth: '300px',
						}}
					>
						{/* <h4 style={{ margin: '0 0 12px 0', color: '#495057', fontSize: '14px', fontWeight: 'bold' }}>Upload Statistics</h4> */}
						{(() => {
							const stats = calculateStatistics();
							return (
								<div style={{ fontSize: '12px', color: '#6c757d' }}>
									<div style={{ marginBottom: '4px' }}>
										<strong style={{ fontSize: '14px' }}>Total Lease
											Count:</strong> {stats.uniqueLeaseCount}
									</div>
									<div style={{ marginBottom: '4px' }}>
										<strong style={{ fontSize: '14px' }}>Total Row
											Count:</strong> {stats.totalRowCount}
									</div>
								</div>
							);
						})()}
					</div>
				)}
			</div>

			<Form
				name="basic"
				layout="vertical"
				labelCol={{
					span: 12,
				}}
				wrapperCol={{
					span: 24,
				}}
			>
				<Row gutter={[24, 24]}>
					<Col xs={24} sm={24} md={24} xl={24}>
						<Form.Item
							rules={[
								{
									required: true,
								},
							]}
						>
							{(!uiState?.show || uiState.validationFailed) && (
								<>
									<Dragger
										name="file"
										customRequest={({ file }) => {
											handleFileUpload(file, validateData, setShow);
										}}
										showUploadList={false}
										accept=".xlsx, .xls" // Specify the accepted file types (Excel files)
									>
										<p className="ant-upload-drag-icon">
											<InboxOutlined />
										</p>
										<p className="ant-upload-text">Click or drag Excel file to this area to
											upload</p>
										<p className="ant-upload-hint">Support for .xlsx and .xls files.</p>
									</Dragger>

									{uiState.validationFailed && (
										<div
											style={{
												marginTop: '20px',
												textAlign: 'center',
												padding: '16px',
												background: '#f6f6f6',
												border: '1px dashed #d9d9d9',
												borderRadius: '4px',
											}}
										>
											<p style={{ color: '#ff4d4f', marginBottom: '8px', fontWeight: 'bold' }}>
												The uploaded Excel file is empty. Please upload a file that contains
												lease data.
											</p>
											<Button
												size="small"
												type="primary"
												onClick={(e) => {
													e.stopPropagation();
													exportExcelFileWithGuidelines(INITIAL_EXPORT_DATA, 'LRM_BulkUpload.xlsx');
												}}
												style={{ backgroundColor: '#1e3a8a' }}
											>
												Download Template
											</Button>
										</div>
									)}
								</>
							)}

							<br></br>

							{uiState.show && data.excelData && !uiState.validationFailed && (
								<Box>
									<TableContainer
										sx={{
											width: '100%',
											overflowX: 'auto',
											overflowY: 'auto',
											position: 'relative',
											display: 'block',
											maxWidth: '100%',
											maxHeight: '70vh',
											height: '70vh',
											'& td, & th': { whiteSpace: 'nowrap' },
											border: '1px solid #000000',
											borderRadius: '4px',
											padding: '0px',
											boxSizing: 'border-box',
										}}
									>
										<Table
											stickyHeader
											aria-labelledby="tableTitle"
											sx={{
												'& .MuiTableCell-root:first-of-type': {
													pl: 2,
												},
												'& .MuiTableCell-root:last-of-type': {
													pr: 3,
												},
												borderCollapse: 'collapse',
											}}
										>
											<TableHead
												sx={{
													'& .MuiTableCell-root': {
														position: 'sticky',
														top: 0,
														zIndex: 2,
														boxShadow: 'inset 0 -1px 0 #333333',
													},
												}}
											>
												<TableRow
													style={{
														backgroundColor: '#e5e5e5',
													}}
												>
													{TABLE_COLUMNS.map((headCell, index) => (
														<TableCell
															key={index}
															align={headCell.align || 'left'}
															padding={headCell.disablePadding ? 'none' : 'normal'}
															style={{
																zIndex: 1,
																// borderBottom: '2px solid #333333 !important',
															}}
														>
															{headCell.label === 'Row No' && (
																<img src={excel} alt="excel" width={22}
																	 style={{ marginRight: '5px' }} />
															)}{' '}
															{headCell.label}
														</TableCell>
													))}
												</TableRow>
											</TableHead>

											<TableBody>
												{data.excelTable?.map((lrm, index) => (
													<OptimizedTableRow
														key={`${lrm['Data No.']}-${index}`}
														lrm={lrm}
														index={index}
														columns={TABLE_COLUMNS}
														getCellStyle={getCellStyle}
														getCellContent={getCellContent}
														tableData={data.excelTable} // Pass the full table data
													/>
												))}
											</TableBody>
										</Table>
									</TableContainer>
								</Box>
							)}
						</Form.Item>
					</Col>

					<Col xs={24} sm={24} md={24} xl={24}>
						<Flex justify="flex-end" align="flex-end">
							{uiState.show && !uiState.validationFailed && (
								<>
									<Button
										style={{ backgroundColor: theme.palette.error?.main, marginRight: '10px' }}
										type="primary"
										onClick={(e) => {
											e.preventDefault();
											setExcelTable([]);
											setShow(false);
											setValidationFailed(false);
											setData((prev) => ({ ...prev, emptyFileError: false }));
										}}
									>
										Cancel
									</Button>

									<Button
										// disabled={uiState?.validationFailed}
										disabled={uiState?.fileSubmitButton}
										style={{ backgroundColor: uiState?.fileSubmitButton ? '' : theme.palette.lynTheme.submit }}
										type="primary"
										onClick={(e) => {
											e.preventDefault();
											handleExcelSubmit();
										}}
									>
										Submit
									</Button>
								</>
							)}
						</Flex>
					</Col>
				</Row>
			</Form>

			{uiState?.showModal && (
				<ComptrollerConfirmModal
					showModal={uiState?.showModal}
					setShowModal={setShowModal}
					modalData={data?.modalInfo}
					handleSubmit={handleSubmitExcelData}
				/>
			)}
		</div>
	);
};

export default LeaseBulkUploadForTestBed;
